// React and Hooks
import React, { useEffect, useRef, useState } from "react";

// Date-related
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker, DatePicker } from "@mui/x-date-pickers";
import Control from "react-leaflet-custom-control";

import { useLocation, useNavigate } from "react-router-dom";

// Styles and CSS

import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";

// MUI and Icons
import { GoLocation } from "react-icons/go";
import { FaCircle } from "react-icons/fa";
import { AiOutlineFileAdd } from "react-icons/ai";
import { MdCancel } from "react-icons/md";

// Bootstrap
import {
  Alert,
  Button,
  Col,
  Dropdown,
  Modal,
  NavDropdown,
  Offcanvas,
  OverlayTrigger,
  Row,
  Tab,
  Tabs,
  Tooltip,
  useAccordionButton,
} from "react-bootstrap";
import { MdDoubleArrow } from "react-icons/md";
// Leaflet and Map-related
import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  Polyline,
  GeoJSON,
  LayersControl,
  Marker,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import * as turf from "@turf/turf";
import toGeoJSON from "@mapbox/togeojson";

// Utilities and Services
import axios from "axios";
import JSZip from "jszip";
import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import AuthServiceV3 from "../../../services/Operation.serviceV3.js";
import UserService from "../../../services/user.service";
import Static_modal from "../etc/Static_modal.js";
import { responsiveFontSizes } from "@mui/material";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

function PolygonLeafLet() {
  const [sidebarMain, setSidebarMain] = useState(false); //
  const [displayPlans, setDisplayPlans] = useState(1); //
  const [createdPolygon, setCreatedPolygon] = useState([]); //
  const [showEstimateSuccess, setShowEstimateSuccess] = useState(false); //
  const [centerBetweenPolygon, setCenterBetweenPolygon] = useState([]);
  const [estimateSuccessStatus, setEstimateSuccessStatus] = useState({
    status: null,
    time: null,
  }); //
  const [estimateID, setEstimateID] = useState("");
  let Navigate = useNavigate();
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  const [shortestPathMarker, setShortestPathMarker] = useState([]);
  const [shortestPathgGeoJson, setShortestPathgGeoJson] = useState();
  const [shortestPathUpperHeight, setShortestPathUpperHeight] = useState(90);
  const [isShortestPathFound, setIsShortestPathFound] = useState(false);

  const [checkboxComfirmation, setCheckboxConfirmation] = useState(null);

  const [operationType, setOperationType] = useState("");
  const [operationScenario, setOperationScenario] = useState("");
  const [estimatedOperationFile, setEstimatedOperationFile] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSendcoop, setShowSendcoop] = useState(false);
  const [showSend, setShowSend] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErroroperation, setShowErroroperation] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [showNoNight, setShowNoNight] = useState(false);
  const [chosenForm, setChosenForm] = useState(1);
  const [agreementPage, setAgreementPage] = useState(1);
  const [populationShow, setPopulationShow] = useState(true);

  const [conditionFLight, setConditionFlight] = useState([
    {
      content:
        "ผู้บังคับหรือปล่อยอากาศยานต้องสามารถมองเห็นอากาศยานได้ตลอดเวลาที่ทำการบิน และห้ามทำการบังคับอากาศยานโดยอาศัยชุดกล้องบนอากาศยานหรืออุปกรณ์อื่นที่มีลักษณะใกล้เคียง",
      agree: false,
    },
    {
      content:
        "ห้ามทำการบินเหนือเมือง หมู่บ้าน ชุมชน หรือพื้นที่ที่มีคนมาชุมนุมอยู่",
      agree: false,
    },
    {
      content:
        "ห้ามทำการบินโดยมีระยะห่างในแนวราบกับบุคคล ยานพาหนะสิ่งก่อสร้าง หรืออาคาร น้อยกว่าสามสิบเมตร (หนึ่งร้อยฟุต)",
      agree: false,
    },
    {
      content:
        " ห้ามทำการบินโดยมีระยะห่างในแนวราบกับบุคคล ยานพาหนะสิ่งก่อสร้าง อาคาร ที่ไม่เกี่ยวข้องกับการปฏิบัติการบินน้อยกว่าห้าสิบเมตร (หนึ่งร้อยห้าสิบฟุต)",
      agree: false,
    },
  ]);

  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  const presentTime = dayjs(new Date());
  const desiredLimit = dayjs(new Date() - 1 * 24 * 60 * 60 * 1000);
  const [dayTimeStart, setDayTimeStart] = useState(
    dayjs(new Date()).add(1, "hour")
  );
  const [dayTimeEnd, setDayTimeEnd] = useState(
    dayjs(new Date(timeStringToInt(dayTimeStart) + 600000))
  );

  const [coopStartTime, setCoopStartTime] = useState("");
  const [coopEndTime, setCoopEndTime] = useState("");

  const [selectedPilot, setSelectedPilot] = useState("");
  const [selectedPilotAge, setSelectedPilotAge] = useState(0);
  const [chosenHeight, setChosenHeight] = useState([90, 90, 90]);
  const [isTimeBeingSet, setIsTimeBeingSet] = useState(false);
  const [availablePilot, setAvailablePilot] = useState([]);
  const [availableDrone, setAvailableDrone] = useState([]);
  const [availableDroneID, setAvailableDroneID] = useState("");

  const [firstDropDownID, setFirstDropDownID] = useState();
  const [secondDropDownID, setSecondDropDownID] = useState();
  const [selectedDrone, setselectedDrone] = useState("");
  const [selectedDroneWeight, setselectedDroneWeight] = useState(0);

  const [filename, setFilename] = useState(undefined);
  const [readFileDone, setReadFileDone] = useState(false);
  const [fileHeight, setFileHeight] = useState([]);

  const [simplifiedKMLPosition, setSimplifiedKMLPosition] = useState([]);
  const [wrongFormat, setWrongFormat] = useState(false);
  const [polygonArray, setPolygonArray] = useState([]);
  const [layerArray, setLayerArray] = useState([]);
  const [tempArrayID, setTempArrayID] = useState([]);
  const [polygonToDelete, setPolygonToDelete] = useState([]);
  const [intersection, setIntersection] = useState(false);
  const [areaIntersection, setAreaIntersection] = useState("");
  const [mapposition, setMapPosition] = useState([
    100.92994760607247, 13.101029105523143,
  ]);
  const [specificData, setSpecificData] = useState([]);
  const mapRef = useRef();
  const [availablePurpose, setAvailablePurpose] = useState([]);
  const [fetchedPurpose, setFetchedPurpose] = useState([]);
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [etcPurposeContent, setEtcPurposeContent] = useState("");
  const [selectedPurposeText, setSelectedPurposeText] = useState([]);
  const [ninetyHeight, setNinetyHeight] = useState(false);
  const [cooperative, setCooperative] = useState(false);
  const [coopUnit, setCoopUnit] = useState("");
  const [searchCoop, setSearhCoop] = useState(false);
  const [CoopId, setCoopId] = useState("");
  const [coopArea, setCoopArea] = useState([]);

  const [isCoopFound, setIsCoopFound] = useState(false);
  const [isCoopFoundOnUsage, setIsCoopFoundOnUsage] = useState(true);
  const [searchcheck, setSearchcheck] = useState(0);
  const [estimatedInfo, setEstimatedInfo] = useState([]);
  const [isEstimateAble, setIsEstimatable] = useState(true);
  const [prohibitPolygon, setProhibitPolygon] = useState([]);
  const [allReservedArea, setAllReservedArea] = useState([]);
  const [timedReservedArea, setTimedReservedArea] = useState([]);
  const [thailandProvince, setThailandProvince] = useState();
  const [PDRArea, setPDRArea] = useState();
  const [Aerodrome, setAeroDrome] = useState();
  const [hospital, setHospital] = useState();
  const [govOffice, setGovOffice] = useState();
  const [thaiGov, setThaiGov] = useState();
  const [embassy, setEmbassy] = useState();
  const [prohibitedAres, setProhibitedAres] = useState();
  const [restrictedAreas, setRestrictedAreas] = useState();
  const [dangerAreas, setDangerAres] = useState();
  const [bangkokPopulation, setBangkokPopulation] = useState();
  const [policeDepartment, setPoliceDepartment] = useState();
  const [isEdited, setIsEdited] = useState([]);
  // const [confirmSend, setConfirmSend] = useState(false);
  const hiddenFileInput = useRef(null);
  const agreementContent = [
    {
      text: "สถานที่ที่จะปฏิบัติการบิน: (คำอธิบายรายละเอียดของตำแหน่งที่ปฏิบัติการบิน หรือขอบเขตของพื้นทีปฏิบัติการอาจจะต้องจัดเตรียมซึ่งอาจระบุไว้ในพิกัดละติจูดและลองจิจูด)",
      status: "-",
    },
    {
      text: "วันและเวลาที่เสนอเพื่อปฏิบัติการบิน (สูงสุด 5 คืน ภายในหนึ่งเดือนตามปฏิทิน)",
      status: "-",
    },
    {
      text: "ระบบเพื่อความปลอดภัยในการบิน ได้แก่ ระบบบันทึกการบิน (Flight Log) และระบบรับรู้ทางภูมิศาสตร์(Geo-Awareness)",
      status: "-",
    },
    {
      text: "ไฟแสดงตำแหน่ง (Navigation Lighting) และควรติดตั้งระบบไฟป้องกันการชน (Strobe or Anti-CollisionLight)",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)ควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้หรือซอฟต์แวร์ของชุด",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)หรือซอฟต์แวร์ของชุดควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้",
      status: "-",
    },
    {
      text: "ระบบป้องกันการชนและการหลบหลีกสิ่งกีดขวาง",
      status: "-",
    },
    {
      text: "ชุดอุปกรณ์ด้านความปลอดภัย ได้แก่ ชุดสะท้อนแสงรองเท้านิรภัย สำหรับนักบิน บุคลากรและเจ้าหน้าที่ที่เกี่ยวข้องกับการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "นักบินมีความรู้เกี่ยวกับกฎหมาย กฎระเบียบ ที่เกี่ยวข้องกับอากาศยานซึ่งไม่มีนักบิน และมีความรู้ความชำนาญในการบังคับอากาศยานและใช้ระบบของอากาศยานที่ใช้ในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีผู้ช่วยสังเกตการบิน (Visual Observer, VO) ซึ่งนักบินรับรองว่าเป็นผู้มีความสามารถปฏิบัติการบินดังกล่าว",
      status: "-",
    },
    {
      text: "มีการสื่อสารที่มีประสิทธิภาพระหว่างนักบิน และผู้ช่วยสังเกตการบินตลอดระยะเวลาในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีการทำประกันภัยสำหรับความเสียหายอันเกิดแก่ร่างกาย ชีวิต ตลอดจนทรัพย์สินของบุคคลที่สามวงเงินประกันไม่ต่ำกว่าหนึ่งล้านบาทต่อครั้ง",
      status: "-",
    },
    {
      text: "นักบิน และ/หรือ ผู้ช่วยสังเกตการบิน สามารถมองเห็นห้วงอากาศรอบข้างได้ตลอดเวลาปฏิบัติการบิน",
      status: "-",
    },
    {
      text: `นักบินต้องรักษาการสื่อสารที่มีประสิทธิภาพกับผู้ช่วยสังเกตการบิน เพื่อให้ทราบตำแหน่ง ระดับความสูง ท่าทางการบิน 
      และตำแหน่งของอากาศยานอย่างต่อเนื่อง รวมถึงข้อมูลสิ่งกีดขวาง เพื่อหลีกเลี่ยงการชนกันเพื่อความปลอดภัยในการปฏิบัติการบิน`,
      status: "-",
    },
    {
      text: "ผู้ช่วยสังเกตการบินแต่ละคนจะต้องไม่สังเกตการอาากศยานมากกว่า 1 ลำหรือช่วยสนับสนุนนักบินมากกว่าหนึ่งคนในเวลาเดียวกัน และไม่ควรได้รับมอบหมายหน้าที่อื่นๆ พร้อมกัน",
      status: "-",
    },
    {
      text: `ทำการสำรวจพื้นที่ปฏิบัติการและประเมินด้านความปลอดภัย (Conduct site and Flight safety assessment)ในเวลากลางวัน 
      เพื่อให้ทราบสภาพสถานที่ และแนวทางที่เหมาะสมในการปฏิบัติการบินรวมถึงกรอกแบบฟอร์มการสำรวจพื้นที่และแบบฟอร์มที่เกี่ยวข้องให้ครบถ้วน`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: "นักบินจะต้องได้รับข้อมูลที่เกี่ยวข้อง ได้แก่ ทัศนวิสัย ภาคพื้นดิน ฐานเมฆ ความเร็วลม และปริมาณน้ําฝน ของพื้นที่ปฏิบัติการบินจากกรมอุตุนิยมวิทยา",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินในพื้นที่หวงห้ามเฉพาะ พื้นที่หวงห้าม เด็ดขาด หรือพื้นที่อันตราย และไม่ทําการบรรทุกวัตถุอันตราย",
      status: "-",
    },
    {
      text: `ต้องปฏิบัติตามข้อกําหนดอื่น ได้แก่ \n
      1.)ปฏิบัติการบินในระยะสายตา \n
      2.)ใช้ระดับความสูงไม่เกิน 300 ฟุต \n
      3.)รักษาระยะห่างด้านข้างกับบุคคล ยานพาหนะ หรือ โครงสร้างที่ไม่เกี่ยวข้องใด ๆ \n
      4.)ไม่ปฏิบัติการบินบรรทุกคน หรือสัตว์ \n
      5.)ไม่ปฏิบัติการบินทิ้งสิ่งของจากอากาศยาน \n
      6.)ไม่ปฏิบัติการบินอากาศยานมากกว่า 1 ลํา ในเวลา เดียวกัน`,
      status: "-",
    },
    {
      text: "บริเวณภาคพื้นดิน สามารถมองเห็นได้ชัดเจน โดย นักบิน ผู้ช่วยสังเกตการบิน และ/หรือพนักงาน สนับสนุน เพื่อให้การบังคับและมองเห็น อากาศยานเป็นไปอย่างมีประสิทธิภาพ",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินเข้าไปในเมฆ",
      status: "-",
    },
    {
      text: "นักบินต้องสามารถทราบความเร็วลม บริเวณพื้นผิว ของพื้นที่ที่จะปฏิบัติการบินและความเร็วลมไม่เกินกว่าที่บริษัทผู้ผลิตอากาศยานกําาหนด",
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไก ป้องกันด้านความปลอดภัย (Fail-Safe Mechanism) สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน 
      เช่นการสูญเสียค่าสั่งควบคุม (Loss of Command) และการ เชื่อมโยงการควบคุม (Control Link) การสูญเสียอุปก รณ์น้าทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: "กรณีเกิดอุบัติเหตุ ซึ่งมีบุคคลบาดเจ็บหรือทรัพย์สินเกิด ความเสียหาย ให้แจ้งตํารวจ และรายงานฝ่ายมาตรฐานอากาศยานซึ่งไม่มีนักบิน ที่uas ur@caat.or.th โดยเร็วทั้งนี้ไม่เกิน 24 ชั่วโมงนับจากเกิดเหตุ",
      status: "-",
    },
    {
      text: `ผู้ได้รับอนุญาตจะต้องให้รายละเอียดเพิ่มเติม และ/หรือ ผลการสอบสวนภายใน 3 วัน 
      โดยเป็นลายลักษณ์ อักษรทางอีเมล์ที บอร ur@caat.or.th บันทึก เหตุการณ์ ทั้งหมดจะต้องได้รับเก็บการดูแลอย่างเหมาะสม`,
      status: "-",
    },
    {
      text: `ไฟแสดงตําแหน่ง (Navigation Lighting) ต้องเปิดอยู่ ตลอดเวลาในขณะปฏิบัติการบิน เพื่อให้นักบิน และ/หรือผู้ช่วยสังเกตการบินสามารถมองเห็นระบุ คําแหน่ง ทิศทาง ของอากาศยาน`,
      status: "-",
    },
    {
      text: `ก่อนขึ้นปฏิบัติการบิน อากาศยานจะต้องสามารถ เชื่อมต่อสัญญาณดาวเทียมได้ (Achieve a Positive Satellite Lock) อย่างน้อย 7 ดวง`,
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไกป้องกันความไม่ปลอดภัย (Fail-Safe Mechanism) 
      สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน เช่นการ สูญเสียค่าสั่งควบคุม (Loss of Command) และ เชื่อมต่อ (Control Link) การสูญเสียไฟนําทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: `ซอฟต์แวร์ของชุดควบคุม (Remote Controller Software)จะต้องสามารถระบุตําแหน่งของอากาศยานที่เป็นปัจจุบันได้`,
      status: "-",
    },
    {
      text: `มีผู้ช่วยสังเกตการบิน (Visual Observer)`,
      status: "-",
    },
  ];

  const handleChangePilot = (pilot) => {
    const selectedPilot = JSON.parse(pilot);
    setSelectedPilot(parseInt(selectedPilot.pilotID));
    setSelectedPilotAge(selectedPilot.pilotAge);
    const checkPilotAndDroneData = AuthServiceV3.CheckPilotAndDroneData(
      parseInt(selectedPilot.pilotID),
      parseInt(selectedDrone.split(" - ")[0], 10),
      firstDropDownID,
      selectedPurpose
    );

    if (checkPilotAndDroneData) {
      checkPilotAndDroneData
        .then((response) => {
          setCheckboxConfirmation(response.data.planing.checkbox);
          setSecondDropDownID(response.data.dropdown_id);
        })
        .catch((err) => {
          console.log(err);
          switch (err) {
            case "Insurance expired.":
              setTextBody("ประกันอุบัติเหตุของอากาศยานหมดอายุ");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Pilot is under 20 years old":
              setTextBody("นักบินมีอายุต่ำกว่า 20 ปี");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Insurance coverage is insufficient for this flight condition. It must not be less than 1,000,000.":
              setTextBody("วงเงินประกันไม่ต่ํากว่า 1 ล้านบาท");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Insurance coverage is insufficient for this flight condition. It must not be less than 2,000,000.":
              setTextBody("วงเงินประกันไม่ต่ํากว่า 2 ล้านบาท");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Insurance information is missing or incomplete.":
              setTextBody("ข้อมูลประกันอุบัติเหตุไม่ถูกต้อง");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Database error":
              setTextBody("เกิดความผิดพลาดทางข้อมูล");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Operation start time is less than 10 minutes from now":
              setTextBody(
                "เวลาเริ่มต้นปฏิบัติการต้องมากกว่า เวลาปัจจุบันอย่างน้อย 10 นาที"
              );
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Operation start time must be less than operation end time":
              setTextBody("เวลาเริ่มต้นปฏิบัติการ เริ่มหลังเวลาสิ้นสุด");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Operation time must not exceed 3 hours":
              setTextBody("เวลาปฏิบัติการเกินกำหนด 3 ชั่วโมง");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "The system does not support this flight condition.":
              setTextBody("ระบบยังไม่รองรับเงื่อนไขการบินนี้");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Pilot cannot do this operation. Use SPECIFIC pilot":
              setTextBody("กรุณาเลือกนักบินประเภท Specific");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Invalid purpose":
              setTextBody("วัตถุประสงค์ไม่ถูกต้อง");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Dropdown data not found":
              setTextBody("กรุณาเลือกเวลาทำการบินใหม่");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Pilot is in used":
              setTextBody("นักบินท่านนี้มีปฏิบัติการในช่วงเวลานี้");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Drone is in used":
              setTextBody("อากาศยานลำนี้มีปฏิบัติการในช่วงเวลานี้");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            default:
              setTextBody(err);
              setModalToggle({ ...modalToggle, modalErr: true });
          }
          // setTextBody(err);
          // setModalToggle({
          //   ...modalToggle,
          //   modalErr: true,
          // });
          setCheckboxConfirmation(null);
          setSecondDropDownID();
          setSelectedPilot("");
        });
    }
  };

  // ██╗███╗░░██╗██╗████████╗██╗░█████╗░████████╗███████╗  ██████╗░░█████╗░████████╗░█████╗░
  // ██║████╗░██║██║╚══██╔══╝██║██╔══██╗╚══██╔══╝██╔════╝  ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  // ██║██╔██╗██║██║░░░██║░░░██║███████║░░░██║░░░█████╗░░  ██║░░██║███████║░░░██║░░░███████║
  // ██║██║╚████║██║░░░██║░░░██║██╔══██║░░░██║░░░██╔══╝░░  ██║░░██║██╔══██║░░░██║░░░██╔══██║
  // ██║██║░╚███║██║░░░██║░░░██║██║░░██║░░░██║░░░███████╗  ██████╔╝██║░░██║░░░██║░░░██║░░██║
  // ╚═╝╚═╝░░╚══╝╚═╝░░░╚═╝░░░╚═╝╚═╝░░╚═╝░░░╚═╝░░░╚══════╝  ╚═════╝░╚═╝░░╚═╝░░░╚═╝░░░╚═╝░░╚═╝

  const checkoperator = () => {
    const operatorid = sessionStorage.getItem("operator_id");
    if (operatorid === "null" || operatorid === undefined) {
      setShowErroroperation(true);
      setTimeout(() => {
        setShowErroroperation(false);
        Navigate("/user/drone/statusDrone");
      }, 2000);
    } else {
      const check = AuthServiceV2.NewToken()
        .then()
        .catch((error) => {
          // setTextBody(error);
          // setModalToggle({ ...modalToggle, modalErr: true });
          console.log(error);
        });
    }
  };

  const getPurposes = () => {
    const purposeList = AuthServiceV2.DronePurposes();
    if (purposeList) {
      purposeList
        .then((response) => {
          const responseData = response.data.data;
          setFetchedPurpose(responseData);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };

  useEffect(() => {
    try {
      checkoperator();
      getPurposes();
    } catch (error) {
      setTextBody(error);
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }, []);

  // ██╗░░░░░░█████╗░░█████╗░░█████╗░████████╗███████╗  ███╗░░░███╗███████╗
  // ██║░░░░░██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝  ████╗░████║██╔════╝
  // ██║░░░░░██║░░██║██║░░╚═╝███████║░░░██║░░░█████╗░░  ██╔████╔██║█████╗░░
  // ██║░░░░░██║░░██║██║░░██╗██╔══██║░░░██║░░░██╔══╝░░  ██║╚██╔╝██║██╔══╝░░
  // ███████╗╚█████╔╝╚█████╔╝██║░░██║░░░██║░░░███████╗  ██║░╚═╝░██║███████╗
  // ╚══════╝░╚════╝░░╚════╝░╚═╝░░╚═╝░░░╚═╝░░░╚══════╝  ╚═╝░░░░░╚═╝╚══════╝

  const showMyLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (mapRef.current) {
            mapRef.current.flyTo(
              [position.coords.latitude, position.coords.longitude],
              17,
              {
                animate: true,
              }
            );
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    }
    if (mapRef.current) {
      mapRef.current.flyTo([13.102617437258145, 100.88806223049966], 15, {
        animate: true,
      });
    }
  };

  // ░█████╗░██████╗░███████╗░█████╗░████████╗██╗███╗░░██╗░██████╗░  ░█████╗░███████╗
  // ██╔══██╗██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██║████╗░██║██╔════╝░  ██╔══██╗██╔════╝
  // ██║░░╚═╝██████╔╝█████╗░░███████║░░░██║░░░██║██╔██╗██║██║░░██╗░  ██║░░██║█████╗░░
  // ██║░░██╗██╔══██╗██╔══╝░░██╔══██║░░░██║░░░██║██║╚████║██║░░╚██╗  ██║░░██║██╔══╝░░
  // ╚█████╔╝██║░░██║███████╗██║░░██║░░░██║░░░██║██║░╚███║╚██████╔╝  ╚█████╔╝██║░░░░░
  // ░╚════╝░╚═╝░░╚═╝╚══════╝╚═╝░░╚═╝░░░╚═╝░░░╚═╝╚═╝░░╚══╝░╚═════╝░  ░╚════╝░╚═╝░░░░░

  // ██████╗░░█████╗░██╗░░░░░██╗░░░██╗░██████╗░░█████╗░███╗░░██╗
  // ██╔══██╗██╔══██╗██║░░░░░╚██╗░██╔╝██╔════╝░██╔══██╗████╗░██║
  // ██████╔╝██║░░██║██║░░░░░░╚████╔╝░██║░░██╗░██║░░██║██╔██╗██║
  // ██╔═══╝░██║░░██║██║░░░░░░░╚██╔╝░░██║░░╚██╗██║░░██║██║╚████║
  // ██║░░░░░╚█████╔╝███████╗░░░██║░░░╚██████╔╝╚█████╔╝██║░╚███║
  // ╚═╝░░░░░░╚════╝░╚══════╝░░░╚═╝░░░░╚═════╝░░╚════╝░╚═╝░░╚══╝

  const handleCreation = (e) => {
    const { layer } = e;
    let positions = [];
    if (layer instanceof L.Circle) {
      positions = calculateCircleMarkers(layer);
      setCreatedPolygon((previous) => [
        ...previous,
        { coordinate: positions, isIntersected: false },
      ]);
    } else if (layer instanceof L.Polygon) {
      positions = convertPolygonToCoordinates(layer);
      setCreatedPolygon((previous) => [
        ...previous,
        { coordinate: positions, isIntersected: false },
      ]);
    } else if (layer instanceof L.Polyline && layer.getLatLngs().length === 2) {
      setShortestPathMarker(swapPolylineLngLat(layer.getLatLngs()));
    }
    if (mapRef && mapRef.current) {
      mapRef.current.removeLayer(layer);
    } else {
      console.error("Map reference is not available.");
    }
  };

  const calculateCircleMarkers = (layer) => {
    const { lat, lng } = layer.getLatLng();
    const circleRadius = layer._mRadius;
    const numPoints = 36;
    const markerPositions = Array.from({ length: numPoints }, (_, i) => {
      const angleRad = ((2 * Math.PI) / numPoints) * i;
      const deltaX = circleRadius * Math.cos(angleRad);
      const deltaY = circleRadius * Math.sin(angleRad);
      const newLng = lng + deltaX / (111320 * Math.cos(lat * (Math.PI / 180)));
      const newLat = lat + deltaY / 110574;
      return [newLng, newLat];
    });
    markerPositions.push(markerPositions[0]);
    return markerPositions;
  };

  const convertPolygonToCoordinates = (polygon) => {
    const latLngs = polygon.getLatLngs()[0];
    const coordinates = latLngs.map(({ lng, lat }) => [lng, lat]);
    coordinates.push(coordinates[0]);
    return coordinates;
  };

  const swapPolylineLngLat = (polyline) => {
    const swappedPolyline = polyline.map((subArr) => {
      return [subArr.lng, subArr.lat];
    });
    return swappedPolyline;
  };

  const toBase64 = (str) => {
    return btoa(unescape(encodeURIComponent(str)));
  };

  const findShortestPolyline = () => {
    AuthServiceV3.ShortestPath(
      shortestPathMarker[0],
      shortestPathMarker[1],
      shortestPathUpperHeight - 10,
      shortestPathUpperHeight
    ) //Lower ต้องเป็น 10 และ Upper ต้องมากกว่า/เท่ากับ 20
      .then((response) => {
       
        console.log(response)
        setTimeout(() => {
          handleClose_Modal();
        }, 2000);
        const repsoneData = response.data.data.data;
        const polygonCoordinate =
          repsoneData.features[1].geometry.coordinates[0];
        setCreatedPolygon((previous) => [
          ...previous,
          { coordinate: polygonCoordinate, isIntersected: false },
        ]);
        setIsShortestPathFound(true);
        setShortestPathgGeoJson(response.data.data.data);
        let rawGeoJsonData = response.data.data.data.features;
        const jsonString = JSON.stringify(rawGeoJsonData);
        const base64String = toBase64(jsonString);
        sessionStorage.setItem("geoJsonData", jsonString);
        const url = `/user/operation/sphere-shortest-path`;
        window.open(url, "_blank");
        handleClose_Modal();
      })
      .catch((error) => {
        switch (error) {
          case "Distance must be more than 50 meters and less than 2,000 meters":
            setTextBody("กรุณาเลือกพื้นที่ระหว่าง 50 เมตร ถึง 2000 เมตร");
            setModalToggle({ ...modalToggle, modalErr: true });
            break;
          case "Trying to access array offset on value of type null":
            setTextBody("กรุณาเลือกพื้นที่ภายในกรุงเทพ");
            setModalToggle({ ...modalToggle, modalErr: true });
            break;
          case "Start or end coordinates are inside the building":
            setTextBody(
              "จุดเริ่มต้น/จุดสิ้นสุดของท่านอยู่ในสิ่งปลูกสร้าง กรุณาปรับความสูงมากกว่าความสูงของสิ่งปลูกสร้าง หรือสร้างจุดเริ่มต้น/จุดสิ้นสุดใหม่"
            );
            setModalToggle({ ...modalToggle, modalErr: true });
            break;
          case "Upper altitude must be more than 20 meters and less than 90 meters":
            setTextBody("โปรดเลือกความสูงระหว่าง 21-89 เมตร");
            setModalToggle({ ...modalToggle, modalErr: true });
            break;
          default:
            setTextBody("เกิดข้อผิดพลาด");
            setModalToggle({ ...modalToggle, modalErr: true });
        }
        setIsShortestPathFound(false);
        // handleClose_Modal();
      });
  };

  // ██████╗░░█████╗░██╗░░░░░██╗░░░██╗░██████╗░░█████╗░███╗░░██╗  ░█████╗░██████╗░██████╗░░█████╗░██╗░░░██╗
  // ██╔══██╗██╔══██╗██║░░░░░╚██╗░██╔╝██╔════╝░██╔══██╗████╗░██║  ██╔══██╗██╔══██╗██╔══██╗██╔══██╗╚██╗░██╔╝
  // ██████╔╝██║░░██║██║░░░░░░╚████╔╝░██║░░██╗░██║░░██║██╔██╗██║  ███████║██████╔╝██████╔╝███████║░╚████╔╝░
  // ██╔═══╝░██║░░██║██║░░░░░░░╚██╔╝░░██║░░╚██╗██║░░██║██║╚████║  ██╔══██║██╔══██╗██╔══██╗██╔══██║░░╚██╔╝░░
  // ██║░░░░░╚█████╔╝███████╗░░░██║░░░╚██████╔╝╚█████╔╝██║░╚███║  ██║░░██║██║░░██║██║░░██║██║░░██║░░░██║░░░
  // ╚═╝░░░░░░╚════╝░╚══════╝░░░╚═╝░░░░╚═════╝░░╚════╝░╚═╝░░╚══╝  ╚═╝░░╚═╝╚═╝░░╚═╝╚═╝░░╚═╝╚═╝░░╚═╝░░░╚═╝░░░

  // ███╗░░░███╗░█████╗░███╗░░██╗░█████╗░░██████╗░███████╗███╗░░░███╗███████╗███╗░░██╗████████╗
  // ████╗░████║██╔══██╗████╗░██║██╔══██╗██╔════╝░██╔════╝████╗░████║██╔════╝████╗░██║╚══██╔══╝
  // ██╔████╔██║███████║██╔██╗██║███████║██║░░██╗░█████╗░░██╔████╔██║█████╗░░██╔██╗██║░░░██║░░░
  // ██║╚██╔╝██║██╔══██║██║╚████║██╔══██║██║░░╚██╗██╔══╝░░██║╚██╔╝██║██╔══╝░░██║╚████║░░░██║░░░
  // ██║░╚═╝░██║██║░░██║██║░╚███║██║░░██║╚██████╔╝███████╗██║░╚═╝░██║███████╗██║░╚███║░░░██║░░░
  // ╚═╝░░░░░╚═╝╚═╝░░╚═╝╚═╝░░╚══╝╚═╝░░╚═╝░╚═════╝░╚══════╝╚═╝░░░░░╚═╝╚══════╝╚═╝░░╚══╝░░░╚═╝░░░

  function normalSwapLatLon(arr) {
    const tempArray = [];
    if (arr.length > 0) {
      const swappedArray = arr.map((subArr) => {
        return [subArr[1], subArr[0]];
      });
      tempArray.push(swappedArray);
    }
    return tempArray;
  }

  function kmlSwapLatLon(arr) {
    const formattedArray = [];
    if (typeof filename === "undefined") {
      formattedArray.push(
        ...arr[0].map((subArr) => subArr.map((pair) => [pair[1], pair[0]]))
      );
    } else {
      for (let j = 0; j < arr.length; j++) {
        if (arr[j][0] !== undefined) {
          const tempFormattedArray = [];
          for (let k = 0; k < arr[j].length; k += 2) {
            tempFormattedArray.push([arr[j][k + 1], arr[j][k]]);
          }
          formattedArray.push(tempFormattedArray);
        }
      }
    }
    return formattedArray;
  }

  // ███████╗░██████╗████████╗██╗███╗░░░███╗░█████╗░████████╗██╗███╗░░██╗░██████╗░
  // ██╔════╝██╔════╝╚══██╔══╝██║████╗░████║██╔══██╗╚══██╔══╝██║████╗░██║██╔════╝░
  // █████╗░░╚█████╗░░░░██║░░░██║██╔████╔██║███████║░░░██║░░░██║██╔██╗██║██║░░██╗░
  // ██╔══╝░░░╚═══██╗░░░██║░░░██║██║╚██╔╝██║██╔══██║░░░██║░░░██║██║╚████║██║░░╚██╗
  // ███████╗██████╔╝░░░██║░░░██║██║░╚═╝░██║██║░░██║░░░██║░░░██║██║░╚███║╚██████╔╝
  // ╚══════╝╚═════╝░░░░╚═╝░░░╚═╝╚═╝░░░░░╚═╝╚═╝░░╚═╝░░░╚═╝░░░╚═╝╚═╝░░╚══╝░╚═════╝░

  // ██╗███╗░░██╗███████╗░█████╗░██████╗░███╗░░░███╗░█████╗░████████╗██╗░█████╗░███╗░░██╗
  // ██║████╗░██║██╔════╝██╔══██╗██╔══██╗████╗░████║██╔══██╗╚══██╔══╝██║██╔══██╗████╗░██║
  // ██║██╔██╗██║█████╗░░██║░░██║██████╔╝██╔████╔██║███████║░░░██║░░░██║██║░░██║██╔██╗██║
  // ██║██║╚████║██╔══╝░░██║░░██║██╔══██╗██║╚██╔╝██║██╔══██║░░░██║░░░██║██║░░██║██║╚████║
  // ██║██║░╚███║██║░░░░░╚█████╔╝██║░░██║██║░╚═╝░██║██║░░██║░░░██║░░░██║╚█████╔╝██║░╚███║
  // ╚═╝╚═╝░░╚══╝╚═╝░░░░░░╚════╝░╚═╝░░╚═╝╚═╝░░░░░╚═╝╚═╝░░╚═╝░░░╚═╝░░░╚═╝░╚════╝░╚═╝░░╚══╝
  // const close = false

  const handleCheckboxChange = (e, statuteKey, isNested = false) => {
    const statutesToCheck = [
      "statute_2",
      "statute_3",
      "statute_4",
      "statute_5",
    ];
    let allTrue = true;

    for (let statute of statutesToCheck) {
      // console.log(checkboxComfirmation.check_type[statute])
      if (statute !== statuteKey) {
        if (
          checkboxComfirmation.check_type.hasOwnProperty(statute) &&
          !checkboxComfirmation.check_type[statute]
        ) {
          allTrue = false;
          break;
        }
      }
    }

    const { checked } = e.target;

    if (isNested) {
      // Update nested key inside เงื่อนไขพิเศษ
      setCheckboxConfirmation((prevState) => ({
        ...prevState,
        check_type: {
          ...prevState.check_type,
          เงื่อนไขพิเศษ: {
            ...prevState.check_type.เงื่อนไขพิเศษ,
            [statuteKey]: checked,
          },
        },
      }));
    } else {
      if (allTrue) {
        let updatedSpecialConditions =
          checkboxComfirmation.check_type.เงื่อนไขพิเศษ;
        for (let key in updatedSpecialConditions) {
          updatedSpecialConditions[key] = true;
        }

        setCheckboxConfirmation((prevState) => ({
          ...prevState,
          check_type: {
            ...prevState.check_type,
            [statuteKey]: checked,
            เงื่อนไขพิเศษ: updatedSpecialConditions,
          },
        }));
      } else {
        setCheckboxConfirmation((prevState) => ({
          ...prevState,
          check_type: {
            ...prevState.check_type,
            [statuteKey]: checked,
          },
        }));
      }
      // Update top-level key in check_type
    }

    // updateSpecialConditions();
    // console.log(checkboxComfirmation);
  };

  const isAnyTopLevelUnchecked = () => {
    return Object.keys(checkboxComfirmation.check_type).some((key) => {
      return (
        key !== "เงื่อนไขพิเศษ" &&
        key !== "statute_1" &&
        checkboxComfirmation.check_type[key] === false
      );
    });
  };

  function hasOnlySpecificKey(obj, key) {
    const keys = Object.keys(obj);
    // console.log(keys.length === 1 && keys[0] === key)
    return keys.length === 1 && keys[0] === key;
  }

  function checkAllPolygon() {
    setModalToggle({ ...modalToggle, modalwait: true });
    let isIntersectedFound = false;
    let errorMessage = "";
    const intersectionThereshold = [
      [141, "ทับพื้นที่หวงห้าม"],
      [188, "ทับพื้นที่การบินของสนามบิน"],
      [10810, "ทับโรงพยาบาล"],
      [10860, "ทับสำนักงานข้าราชการ"],
      [11023, "ทับที่สถานฑูต"],
      [11111, "ทับที่สถานีตำรวจ"],
      [11187, "ทับที่ทำการข้าราชการ"],
    ];
    if (createdPolygon.length !== 0) {
      const updatedCreatedPolygon = [...createdPolygon];
      const turfedCreatedPolygonArray = createdPolygon.map((content) => {
        return turf.polygon([content.coordinate]);
      });

      const getCentroidEachPolygon = turfedCreatedPolygonArray.map(
        (content) => {
          return turf.centroid(content).geometry.coordinates;
        }
      );
      const getCenterBetweenPolygon = turf.center(
        turf.points(getCentroidEachPolygon)
      ).geometry.coordinates;
      setCenterBetweenPolygon([
        getCenterBetweenPolygon[1],
        getCenterBetweenPolygon[0],
      ]);
      for (let i = 0; i < turfedCreatedPolygonArray.length; i++) {
        const intersectingIndex = prohibitPolygon.findIndex((prohibit) => {
          return turf.booleanIntersects(
            turf.polygon([prohibit.area]),
            turfedCreatedPolygonArray[i]
          );
        });
        if (intersectingIndex !== -1) {
          let intersectionMessages = "";
          intersectionThereshold.some(([threshold, message]) => {
            if (intersectingIndex < threshold) {
              intersectionMessages = message;
              return true;
            }
            return false;
          });
          errorMessage = `พื้นที่ที่เลือก${intersectionMessages} : ${prohibitPolygon[intersectingIndex].name} 
          | ติดต่อ : 
          ${prohibitPolygon[intersectingIndex].referrence}`;
          updatedCreatedPolygon[i] = {
            ...updatedCreatedPolygon[i],
            isIntersected: true,
          };
          isIntersectedFound = true;
        }
      }
      setCreatedPolygon(updatedCreatedPolygon);
    } else {
      errorMessage = "กรุณาวาดรูปทรงเพื่อกำหนดพื้นที่";
    }
    if (
      isIntersectedFound === true ||
      errorMessage === "กรุณาวาดรูปทรงเพื่อกำหนดพื้นที่"
    ) {
      // setTimeout(() => {
      //   handleClose_Modal();
      // }, 2000);
      setTimeout(() => {
        setTextBody(errorMessage);
        setModalToggle({ ...modalToggle, modalErr: true });
      }, 2000);
    } else {
      estimateOperationInfo();
    }
  }
  // }
  // if (
  //   turf.booleanIntersects(
  //     turf.polygon([prohibitPolygon[k].area]),
  //     turfedCreatedPolygonArray[i]
  //   ) === true
  // ) {
  //   console.log("Is Intersected");
  //   const targetPolygonToRed = createdPolygon.filter(
  //     (content, index) => index !== i
  //   );
  //   targetPolygonToRed.push({
  //     coordinate: tempCreatedPolygonArray[i].coordinate,
  //     isIntersected: true,
  //   });
  //   setCreatedPolygon(targetPolygonToRed);
  // }

  // try {
  //   turfPolygonArray = polygonArray.map((polygon) => turf.polygon([polygon]));
  //   if (polygonArray.length > 0) {
  //     //ตรวจสอบระหว่าง Polygon ที่เพิ่งวาดกันเอง (กรณีวาดได้หลาย Polygon ภายใน 1 ครั้ง)
  //     for (let i = 0; i < turfPolygonArray.length; i++) {
  //       const drawnPolygonCoords = turfPolygonArray[i];
  //       let isIntersecting = false;
  //       for (let j = 0; j < turfPolygonArray.length; j++) {
  //         if (
  //           i !== j &&
  //           turf.booleanIntersects(turfPolygonArray[j], drawnPolygonCoords)
  //         ) {
  //           console.log(turfPolygonArray[j]);
  //           isIntersecting = true;
  //           intersectionCount++;
  //           if (chosenForm === 1) {
  //             layerArray[i].setStyle({
  //               color: "red",
  //               fillColor: "lightpink",
  //             });
  //           }
  //           break;
  //         }
  //       }

  //       if (!isIntersecting) {
  //         for (let k = 0; k < prohibitPolygon.length; k++) {
  //           if (
  //             turf.booleanIntersects(
  //               turf.polygon([prohibitPolygon[k].area]),
  //               drawnPolygonCoords
  //             )
  //           ) {
  //             if (k <= 141) {
  //               setAreaIntersection(
  //                 `ทับพื้นที่หวงห้าม \n ${prohibitPolygon[k].name}`
  //               );
  //             } else if (k > 141 && k <= 188) {
  //               setAreaIntersection(
  //                 `ทับพื้นที่การบินของสนามบิน \n ${prohibitPolygon[k].name}`
  //               );
  //             } else if (k > 188 && k <= 10810) {
  //               setAreaIntersection(
  //                 `ทับโรงพยาบาล \n ${prohibitPolygon[k].name}`
  //               );
  //               console.log(prohibitPolygon[k]);
  //             } else if (k > 10810 && k <= 10860) {
  //               setAreaIntersection(
  //                 `ทับสำนักงานข้าราชการ \n ${prohibitPolygon[k].name}`
  //               );
  //             } else if (k > 10860 && k <= 11023) {
  //               setAreaIntersection(
  //                 `ทับที่สถานฑูต \n ${prohibitPolygon[k].name}`
  //               );
  //             } else if (k > 11023 && k <= 11111) {
  //               setAreaIntersection(
  //                 `ทับที่สถานีตำรวจ \n ${prohibitPolygon[k].name}`
  //               );
  //             } else if (k > 11111 && k <= 11187) {
  //               setAreaIntersection(
  //                 `ทับที่ทำการข้าราชการ \n ${prohibitPolygon[k].name}`
  //               );
  //             }
  //             isIntersecting = true;
  //             intersectionCount++;
  //             if (chosenForm === 1 && simplifiedKMLPosition.length === 0) {
  //               layerArray[i].setStyle({
  //                 color: "red",
  //                 fillColor: "lightpink",
  //               });
  //             }
  //             break;
  //           }
  //         }
  //         if (specificData.length > 0) {
  //           for (let s = 0; s < specificData.length; s++) {
  //             if (
  //               turf.booleanIntersects(
  //                 turf.polygon([specificData[s]]),
  //                 drawnPolygonCoords
  //               )
  //             ) {
  //               if (chosenForm === 1 && simplifiedKMLPosition.length === 0) {
  //                 isIntersecting = true;
  //                 intersectionCount++;
  //                 layerArray[i].setStyle({
  //                   color: "red",
  //                   fillColor: "lightpink",
  //                 });
  //                 setAreaIntersection(`ทับที่พื้นที่ที่กำลังขออนุญาต`);
  //               }
  //               break;
  //             }
  //           }
  //         }
  //       }

  //       if (chosenForm === 1) {
  //         if (!isIntersecting && simplifiedKMLPosition.length === 0) {
  //           layerArray[i].setStyle({
  //             color: "green",
  //             fillColor: "lightgreen",
  //           });
  //         }
  //       }
  //     }
  //   }

  //   if (intersectionCount > 0) {
  //     setIntersection(true);
  //     setShowError(true);
  //   } else {
  //     setIntersection(false);
  //     estimateOperationInfo();
  //   }
  // } catch (err) {
  //   setWrongFormat(true);
  //   console.log("Error in the Polygon detection : ", err);
  //   setShowError(true);
  // }

  const handleClose = () => {
    setShowSendcoop(false);
    setShowSend(false);
  };

  const handleShow = () => {
    const isDroneSelected = selectedDrone.length > 0;
    const isPurposeSelected = selectedPurpose.length > 0;
    const isHeightValid = chosenHeight > 19 && chosenHeight < 16001;
    const isEstimatedInfoValid = ![
      "REPEATED",
      "DRONE IN USED",
      "PILOT IN USED",
      "AREA IN USED",
      "INVALID PILOT TYPE",
      "OPEN PILOT ONLY",
      "SPECIFIC PILOT ONLY",
    ].includes(estimatedInfo[1]);

    if (
      isDroneSelected &&
      isPurposeSelected &&
      isHeightValid &&
      isEstimatedInfoValid
    ) {
      const estimatedInfoText = estimatedInfo[1].split("||")[1].trim();
      const pilotType = estimatedInfoText.split("-")[0];

      if (pilotType === "OPEN") {
        setShowSend(true);
      } else if (pilotType === "SPECFIC" || pilotType === "SPECIFIC") {
        setShowAgreement(true);
      }
    } else {
      setShowError(true);
    }
  };

  // ██╗░░██╗░█████╗░███╗░░██╗██████╗░██╗░░░░░███████╗  ████████╗██╗███╗░░░███╗███████╗
  // ██║░░██║██╔══██╗████╗░██║██╔══██╗██║░░░░░██╔════╝  ╚══██╔══╝██║████╗░████║██╔════╝
  // ███████║███████║██╔██╗██║██║░░██║██║░░░░░█████╗░░  ░░░██║░░░██║██╔████╔██║█████╗░░
  // ██╔══██║██╔══██║██║╚████║██║░░██║██║░░░░░██╔══╝░░  ░░░██║░░░██║██║╚██╔╝██║██╔══╝░░
  // ██║░░██║██║░░██║██║░╚███║██████╔╝███████╗███████╗  ░░░██║░░░██║██║░╚═╝░██║███████╗
  // ╚═╝░░╚═╝╚═╝░░╚═╝╚═╝░░╚══╝╚═════╝░╚══════╝╚══════╝  ░░░╚═╝░░░╚═╝╚═╝░░░░░╚═╝╚══════╝

  function timeStringToInt(time) {
    const date = new Date(time);
    return Math.round(date.getTime());
  }

  const shouldDisableStartDate = (date) => {
    return date <= desiredLimit;
  };

  const shouldDisableStartTime = (date) => {
    const hour = new Date(date).getHours();
    const minute = new Date(date).getMinutes();
    return (
      // hour < 6 ||
      // (hour <= 6 && minute < 5) ||
      // hour > 17 ||
      // (hour >= 17 && minute > 55) ||
      new Date(date).getDate() == new Date(desiredLimit).getDate() + 1 &&
      new Date(date).getHours() <= new Date(desiredLimit).getHours()
    );
  };

  const shouldDisableEndDate = (date) => {
    const hour = new Date(date).getHours();
    const minute = new Date(date).getMinutes();
    return date < dayTimeStart || date > dayTimeStart.add(3, "hour");
  };

  const shouldDisableEndTime = (date) => {
    return (
      date < dayTimeStart.add(-24, "hour") || date > dayTimeStart.add(3, "hour")
    );
  };

  const shouldDisableTime = (date) => {
    return (
      new Date(date).getHours() <= 6 ||
      new Date(date).getHours() >= 17 ||
      (new Date(date).getDate() == new Date(desiredLimit).getDate() + 1 &&
        new Date(date).getHours() <= new Date(desiredLimit).getHours())
    );
  };

  const convertTime = (dateTimeString) => {
    let dateAndTimeParts = dateTimeString.split("T");
    let datePart = dateAndTimeParts[0];
    let timePart = dateAndTimeParts[1].split("+")[0];
    let [hours, minutes] = timePart.split(":").slice(0, 2);
    let formattedDateTime = `${datePart} ${hours}:${minutes}`;
    return formattedDateTime;
  };

  function formattingDate(inputDate) {
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");

    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00+07:00`;
    return formattedDate;
  }

  function RenderSpecificedTimePolygon() {
    if (allReservedArea.length > 0) {
      return (
        <Polygon
          pathOptions={{
            color: "orange",
            fillColor: "yellow",
            fillOpacity: 0.6,
          }}
          positions={allReservedArea}
        />
      );
    } else {
      return null;
    }
  }

  // ██╗░░██╗███╗░░░███╗██╗░░░░░  ░██████╗███████╗░█████╗░████████╗██╗░█████╗░███╗░░██╗
  // ██║░██╔╝████╗░████║██║░░░░░  ██╔════╝██╔════╝██╔══██╗╚══██╔══╝██║██╔══██╗████╗░██║
  // █████═╝░██╔████╔██║██║░░░░░  ╚█████╗░█████╗░░██║░░╚═╝░░░██║░░░██║██║░░██║██╔██╗██║
  // ██╔═██╗░██║╚██╔╝██║██║░░░░░  ░╚═══██╗██╔══╝░░██║░░██╗░░░██║░░░██║██║░░██║██║╚████║
  // ██║░╚██╗██║░╚═╝░██║███████╗  ██████╔╝███████╗╚█████╔╝░░░██║░░░██║╚█████╔╝██║░╚███║
  // ╚═╝░░╚═╝╚═╝░░░░░╚═╝╚══════╝  ╚═════╝░╚══════╝░╚════╝░░░░╚═╝░░░╚═╝░╚════╝░╚═╝░░╚══╝

  function formatKMLElement(arr) {
    const formattedArray = [];
    for (let j = 0; j < arr.length; j++) {
      if (arr[j][0] !== undefined) {
        const tempFormattedArray = [];
        for (let k = 0; k < arr[j].length; k += 2) {
          tempFormattedArray.push([arr[j][k], arr[j][k + 1]]);
        }
        formattedArray.push(tempFormattedArray);
      }
    }
    return formattedArray;
  }
  const convertKMZFile = async (kmzfile) => {
    const zip = new JSZip();
    try {
      const kmzData = await zip.loadAsync(kmzfile);
      const kmlData = await kmzData.file("doc.kml").async("string");
      return kmlData;
    } catch (error) {
      console.error("Error converting KMZ to KML:", error);
      return null;
    }
  };
  async function handleFileInputChange(event) {
    const file = event.target.files[0];
    if (file !== undefined) {
      setFilename(event.target.files[0].name);
      if (event.target.files[0].name.includes(".kmz")) {
        const kmlData = await convertKMZFile(file);
        getFileContentArray(kmlData);
      } else {
        if (file) {
          const reader = new FileReader();
          reader.onload = function (e) {
            const fileContent = e.target.result;
            getFileContentArray(fileContent);
          };
          reader.readAsText(file);
        }
      }
    }
  }

  const kmlRecursiveRead = (feature) => {
    if (feature.geometry.type === "Polygon") {
      const coordinates = feature.geometry.coordinates[0];
      try {
        const kmlRecursiveReadData = coordinates
          .filter(
            (coord) =>
              !isNaN(coord[0]) &&
              !isNaN(coord[1]) &&
              coord[0] !== undefined &&
              coord[1] !== undefined
          )
          .flatMap((coord) => [coord[0], coord[1]]);
        return [kmlRecursiveReadData];
      } catch (err) {
        return null;
      }
    } else if (feature.geometry.type === "GeometryCollection") {
      const arr = feature.geometry.geometries.map((content) => {
        return kmlRecursiveRead({ geometry: content });
      });
      return arr.flat().filter((content) => content !== null);
    } else {
      return null;
    }
  };

  const getFileContentArray = (fileContent) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(fileContent, "text/xml");
    const geoJsonData = toGeoJSON.kml(xmlDoc);
    if (!geoJsonData) return;
    const positionFileData = geoJsonData.features.map((feature) => {
      return kmlRecursiveRead(feature);
    });
    const arrangedData = positionFileData
      .filter((content) => content !== null)
      .flat();
    const cleanArrangedData = arrangedData.filter(
      (subArray) => subArray.length > 0
    );

    if (cleanArrangedData.length !== 0) {
      const resultArray = cleanArrangedData.map((content) => {
        const resultArray = [];
        for (let i = 0; i < content.length; i += 2) {
          if (i + 1 < content.length) {
            resultArray.push([content[i], content[i + 1]]);
          }
        }
        return resultArray;
      });
      setCreatedPolygon((previous) => [
        ...previous,
        { coordinate: resultArray.flat(), isIntersected: false },
      ]);
      setPolygonArray(resultArray);
      if (mapRef && mapRef.current) {
        const map = mapRef.current;
        map.flyTo([resultArray[0][0][1], resultArray[0][0][0]], 16);
      }
      setWrongFormat(false);
    } else {
      setWrongFormat(true);
      setShowError(true);
    }
  };

  const handleChangeStart = (newValue) => {
    
    if (timeStringToInt(newValue) >= timeStringToInt(presentTime)) {
      setDayTimeStart(newValue);
      setDayTimeEnd(
        dayjs(new Date(timeStringToInt(newValue))).add(10, "minute")
      );
      getOperationAreaData();
    }
  };
  const handleChangeEnd = (newValue) => {
    setDayTimeEnd(newValue);
    getOperationAreaData();
  };

  const getOperationAreaData = () => {
    const dataArea = AuthServiceV2.Opearationdata();
    if (dataArea) {
      dataArea
        .then((response) => {
          const responseData = response.data;
          const allAreaData = [];
          if (responseData != undefined) {
            const agencyData =
              responseData.agency_data.length != undefined
                ? responseData.agency_data
                : [];
            const operatorData =
              responseData.operator_data.length != undefined
                ? responseData.operator_data
                : [];

            for (let i = 0; i < agencyData.length; i++) {
              const areaStartTime = agencyData[i].start_time;
              const areaEndTime = agencyData[i].end_time;
              if (
                dayTimeStart < new Date(areaEndTime) &&
                dayTimeEnd > new Date(areaStartTime)
              ) {
                allAreaData.push(agencyData[i]);
              }
             
            }

            for (let i = 0; i < operatorData.length; i++) {
              const areaStartTime = operatorData[i].start_time;
              const areaEndTime = operatorData[i].end_time;
              const areaStatus = operatorData[i].operation_status
              if (
                dayTimeStart < new Date(areaEndTime) &&
                dayTimeEnd > new Date(areaStartTime) &&
                (areaStatus === 1 || areaStatus === 2)
              ) {
                allAreaData.push(
                  operatorData[
                    i
                  ].operation_area.Volume3D.outline_polygon.vertices.map(
                    (item) => [item.Lat, item.Lon]
                  )
                );
              }
            }

            setAllReservedArea(allAreaData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const legendPopulation = [
    { population: "น้อยกว่า 1000", color: 0.1 },
    { population: "1000-2499", color: 0.2 },
    { population: "2500-4999", color: 0.3 },
    { population: "5000-7499", color: 0.3 },
    { population: "7500-9999", color: 0.5 },
    { population: "10000-14999", color: 0.6 },
    { population: "15000-19999", color: 0.7 },
    { population: "20000-24999", color: 0.8 },
    { population: "มากกว่า 24999", color: 0.9 },
  ];

  const getAvailableInformation = () => {
    const startDate = formattingDate(new Date(dayTimeStart));
    const endDate = formattingDate(new Date(dayTimeEnd));
    const droneAndPilotData = AuthServiceV3.DroneAndPilotData(
      startDate,
      endDate
    );
    if (!droneAndPilotData) return;
    droneAndPilotData
      .then((response) => {
        if (response.data.error_description === undefined) {
          const { dropdown_id, drone_data, pilot_data } = response.data;
          setFirstDropDownID(dropdown_id);
          const droneElement = drone_data.map(
            (drone) =>
              `${drone.drone_id} - ${drone.brand_model} - ${drone.weight}`
          );

          const purposeElement = drone_data.reduce((acc, drone) => {
            if (drone.purpose_etc != null) {
              acc[drone.drone_id] = {
                id: drone.purpose,
                etc_content: drone.purpose_etc,
              };
            } else {
              acc[drone.drone_id] = drone.purpose.filter(
                (value) => value !== 7
              );
            }

            return acc;
          }, {});
          const filteredPilots = Object.values(
            pilot_data.reduce((acc, pilot) => {
              // If pilot with this name already exists
              if (acc[pilot.pilot_name]) {
                // If the existing pilot has an "OPEN" type and the new one is "SPECIFIC", replace it
                if (pilot.pilot_type === "SPECIFIC") {
                  acc[pilot.pilot_name] = pilot;
                }
              } else {
                // Add the pilot to the accumulator if it's the first encounter
                acc[pilot.pilot_name] = pilot;
              }
              return acc;
            }, {})
          );
          const pilotElement = filteredPilots.map(
            (pilot) =>
              `${pilot.co_id}-${pilot.pilot_name}-${pilot.pilot_type}-${pilot.pilot_age}`
          );
          // console.log(response.data);
          // console.log(purposeElement);

          setAvailableDrone(droneElement);
          setAvailablePurpose(purposeElement);
          setAvailablePilot(pilotElement);
        }
      })
      .catch((error) => {
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      });
  };

  const estimateOperationInfo = () => {
    const selectedDroneID = parseInt(selectedDrone.split("-")[0].trim());
    const selectedPurposeID = parseInt(selectedPurpose);
    const selectedPilotID = parseInt(selectedPilot);
    const selectedPosition = createdPolygon.map((item) => item.coordinate);
 
    AuthServiceV3.CheckOperation(
      secondDropDownID,
      checkboxComfirmation.check_type,
      selectedPosition,
      parseInt(chosenHeight),
      2
    )
      .then((response) => {
       
        if (response.data) {
          const responseStatus = response.data.status;
          const responseID = response.data.ID;
          const fullOperationStatus = response.data.status?.split("||");
          const supportAdvanceStatus = fullOperationStatus[0]?.trim();
          const actualOperationStatus = fullOperationStatus[1]?.trim();
          setOperationType(actualOperationStatus.split("-")[1]);
          setOperationScenario(actualOperationStatus.split("-")[0]);
          setEstimatedOperationFile(response.data.operation_detail.files);

          const verifyingPatter = /^.*\s*\|\|\s*.*-.+$/;
          if (verifyingPatter.test(responseStatus) === true) {
            const parts = responseStatus.split("||");
            const [status, day] = parts[1].trim().split("-");
            setEstimateSuccessStatus({ status: status, time: day });
            setEstimateID(responseID);
            setTextBody("");
            setTimeout(() => {
              handleClose_Modal();
              setShowEstimateSuccess(true);
            }, 2000);
          } else {
            setTimeout(() => {
              handleClose_Modal();
            }, 2000);
            setTimeout(() => {
              setTextBody("รูปแบบการส่งข้อมูลกลับไม่ตรงตามที่วางไว้");
              setModalToggle({ ...modalToggle, modalErr: true });
            }, 2000);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        let tempErrorMessage = "";
        // const trimmedErrorMessage =
        //   response.match(/^.*?(?=\s*\()/)?.[0]?.trim() || response.trim();
        switch (error) {
          case "Drone is in uesd":
            tempErrorMessage = "โดรนที่เลือกมีการใช้งานอยู่ในช่วงเวลานี้";
            break;
          case "Pilot is busy":
            tempErrorMessage = "นักบินที่เลือกมีการปฏิบัติงานอยู่ในช่วงเวลานี้";
            break;
          case "This area is already used":
            tempErrorMessage =
              "พื้นที่ที่เลือกมีการปฏิบัติงานอยู่ในช่วงเวลานี้";
            break;
          case "The co id field is required.":
            tempErrorMessage = "โปรดเลือกนักบิน";
            break;
          case "The drone id field is required.":
            tempErrorMessage = "โปรดเลือกอากาศยาน";
            break;
          case "The purpose field is required.":
            tempErrorMessage = "โปรดเลือกวัตถุประสงค์";
            break;
          case "The operation area field is required.":
            tempErrorMessage = "โปรดเลือกพื้นที่";
            break;
          case "Dropdown data not found":
            tempErrorMessage = "โปรดเวลาใหม่เนื่องจากเวลาเริ่มต้นเกินกำหนด";
            break;
          case "Pilot cannot do this operation. Use SPECIFIC pilot":
            tempErrorMessage = "กรุณาเลือกนักบินประเภท Specific";
            break;
          default:
            tempErrorMessage = error;
        }
        // setTimeout(() => {
        //   handleClose_Modal();
        // }, 2000);
        setTimeout(() => {
          setTextBody(tempErrorMessage);
          setModalToggle({ ...modalToggle, modalErr: true });
        }, 2000);
      });
  };

  useEffect(() => {
    if (estimatedInfo.length !== 0) {
      if (estimatedInfo[1] !== "REPEATED") {
        handleShow();
      }
    }
  }, [estimatedInfo]);

  const confirmSendInfo = () => {
    let confirmInfo = AuthServiceV3.ComfirmOperation(estimateID);
    if (confirmInfo != null) {
      confirmInfo
        .then((response) => {
          setShowEstimateSuccess(false);
          setModalToggle({ ...modalToggle, modalSuccess: true });
          setTimeout(() => {
            window.location.reload(false);
          }, 2000);
        })
        .catch((error) => {
          setShowEstimateSuccess(false);
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const getPDFForNight = async (data_id) => {
    let getPDF = AuthServiceV2.NightFlightForm(data_id);
    if (getPDF != null) {
      getPDF.then((response) => {});
    }
  };

  useEffect(() => {
    setSidebarMain(true);
    async function fetchData() {
      try {
        const [
          responsePDRArea,
          responseAeroDrome,
          responseHospital,
          responseGovOffice,
          responseEmbassy,
          responsePoliceDepartment,
          responseThaiGov,
          allGeoData,
          responseBangkokPopulation,
        ] = await Promise.all([
          axios.get("../../PDR-AREA.geojson"),
          axios.get("../../Aerodrome.geojson"),
          axios.get("../../hospitalLocation.geojson"),
          axios.get("../../GovOfficetoutput.geojson"),
          axios.get("../../Embassyoutput.geojson"),
          axios.get("../../PoliceDepartmentoutput.geojson"),
          axios.get("../../ThaiGovoutput.geojson"),
          AuthServiceV2.AllGeoFenceData(),
          axios.get("../../BKK_District.geojson"),
        ]);

        const { prohibited_areas, danger_areas, restricted_areas, aerodrome } =
          allGeoData.data;

        const PDRDataset = {
          type: "FeatureCollection",
          features: [
            ...prohibited_areas.features,
            ...danger_areas.features,
            ...restricted_areas.features,
          ],
        };

        setProhibitedAres(prohibited_areas.features);
        setRestrictedAreas(restricted_areas.features);
        setDangerAres(danger_areas.features);
        setPDRArea(PDRDataset);
        setAeroDrome(aerodrome.features);
        setHospital(responseHospital.data);
        setGovOffice(responseGovOffice.data);
        setThaiGov(responseThaiGov.data);
        setPoliceDepartment(responsePoliceDepartment.data);
        setEmbassy(responseEmbassy.data);
        setBangkokPopulation(responseBangkokPopulation.data);

        const tempAllData = [
          ...aerodrome.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.province,
            referrence: properties.asdf,
          })),
          ...danger_areas.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.name,
            referrence: properties.remarks.Tel,
          })),
          ...prohibited_areas.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.name,
            referrence: properties.remarks.Tel,
          })),
          ...restricted_areas.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.name,
            referrence: properties.remarks.Tel,
          })),
          ...responseHospital.data.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0],
            name: properties.Agency,
            referrence: properties.Department,
          })),
          ...responseGovOffice.data.features.map(
            ({ geometry, properties }) => ({
              area: geometry.coordinates[0],
              name: properties.name,
              referrence: properties.tel,
            })
          ),
          ...responseEmbassy.data.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0],
            name: properties.name_t,
            referrence: properties.tel,
          })),
          ...responsePoliceDepartment.data.features.map(
            ({ geometry, properties }) => ({
              area: geometry.coordinates[0],
              name: properties.name,
              referrence: properties.tel,
            })
          ),
          ...responseThaiGov.data.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0],
            name: properties.name,
            referrence: properties.tel,
          })),
        ];
        setProhibitPolygon(tempAllData);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    }
    fetchData();
    setTimeout(() => {
      getAvailableInformation();
      getOperationAreaData();
    }, 1000);
  }, []);

  useEffect(() => {
    getAvailableInformation();
  }, [isTimeBeingSet]);

  const bangkokPopulationColorized = (feature) => {
    const population = feature.properties.DN;
    return {
      fillColor: "red",
      color: "transparent",
      fillOpacity:
        population < 1000
          ? 0.1
          : population >= 1000 && population < 2500
          ? 0.2
          : population >= 2500 && population < 5000
          ? 0.3
          : population >= 5000 && population < 7500
          ? 0.4
          : population >= 7500 && population < 10000
          ? 0.5
          : population >= 10000 && population < 15000
          ? 0.6
          : population >= 15000 && population < 20000
          ? 0.7
          : population >= 20000 && population < 25000
          ? 0.8
          : 0.9,
    };
  };

  const downloadTxtFile = () => {
    const content = `<?xml version="1.0" encoding="UTF-8"?> 
    <kml xmlns="http://earth.google.com/kml/2.0"> 
        <Document>
            <Placemark> 
                <name>Untitled Polygon</name>
                <styleUrl>#m_ylw-pushpin</styleUrl>
                <Polygon>   
                    <tessellate>1</tessellate>
                    <altitudeMode>absolute</altitudeMode>
                    <outerBoundaryIs>  
                        <LinearRing>
                            <coordinates>
                            106.797494636567,4.653737046372933,0 
                            107.9105999951937,20.18311072920269,0 
                            92.41688357936664,21.16441251608377,0 
                            92.8508903014889,3.853973378567559,0 
                            106.797494636567,4.653737046372933,0 
                            </coordinates>
                        </LinearRing> 
                    </outerBoundaryIs> 
                </Polygon>
                <Style> 
                    <PolyStyle>  
                        <color>#a00000ff</color>
                        <outline>0</outline>
                    </PolyStyle> 
                </Style>
            </Placemark>
        </Document> 
    </kml>`;
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "example.kml";
    a.click();
    URL.revokeObjectURL(url);
  };

  const onEachFeature = (feature, layer) => {
    if (feature.properties && feature.properties.name) {
      layer.bindPopup(feature.properties.name);
    } else if (feature.properties && feature.properties.Ministry) {
      layer.bindPopup(feature.properties.Agency);
    } else if (feature.properties && feature.properties.name_t) {
      layer.bindPopup(feature.properties.name_t);
    }
  };

  const onEachProperties = (feature, layer) => {
    if (
      feature.properties &&
      feature.properties.dataType === "building_intersect"
    ) {
      layer.options.color = "red";
      layer.options.fillColor = "red";
      layer.options.weight = 1.5;
    } else if (
      feature.properties &&
      feature.properties.dataType === "building_not_intersect"
    ) {
      layer.options.color = "grey";
      layer.options.fillColor = "grey";
      layer.options.weight = 1;
      layer.options.fillOpacity = 0.1;
    } else if (
      feature.properties &&
      feature.properties.dataType === "path_line_scaled"
    ) {
      layer.options.color = "green";
      layer.options.fillColor = "lightgreen";
      layer.options.fillOpacity = 0.5;
    } else if (feature.properties && feature.properties.dataType === "node") {
      layer.options.color = "blue";
      layer.options.weight = 5;
    }
  };

  // ██████╗░███████╗███╗░░██╗██████╗░███████╗██████╗░  ███████╗██╗░░░██╗███╗░░██╗░█████╗░████████╗██╗░█████╗░███╗░░██╗
  // ██╔══██╗██╔════╝████╗░██║██╔══██╗██╔════╝██╔══██╗  ██╔════╝██║░░░██║████╗░██║██╔══██╗╚══██╔══╝██║██╔══██╗████╗░██║
  // ██████╔╝█████╗░░██╔██╗██║██║░░██║█████╗░░██████╔╝  █████╗░░██║░░░██║██╔██╗██║██║░░╚═╝░░░██║░░░██║██║░░██║██╔██╗██║
  // ██╔══██╗██╔══╝░░██║╚████║██║░░██║██╔══╝░░██╔══██╗  ██╔══╝░░██║░░░██║██║╚████║██║░░██╗░░░██║░░░██║██║░░██║██║╚████║
  // ██║░░██║███████╗██║░╚███║██████╔╝███████╗██║░░██║  ██║░░░░░╚██████╔╝██║░╚███║╚█████╔╝░░░██║░░░██║╚█████╔╝██║░╚███║
  // ╚═╝░░╚═╝╚══════╝╚═╝░░╚══╝╚═════╝░╚══════╝╚═╝░░╚═╝  ╚═╝░░░░░░╚═════╝░╚═╝░░╚══╝░╚════╝░░░░╚═╝░░░╚═╝░╚════╝░╚═╝░░╚══╝

  function RenderSideBarWrapper({ renderContent }) {
    return (
      <div className="sidebar-wrapper">
        <div
          className="sidebar-card"
          style={{
            boxShadow: "0px 0px 0px 0px",
            backgroundColor: "white",
          }}
        >
          <div className="sidebar-card-body" style={{ height: "auto" }}>
            <div className="form-content">{renderContent}</div>
          </div>
        </div>
      </div>
    );
  }

  function PolygonSlotTemplate({ indexOfCreatedPolygon }) {
    let renderDefaultCoordinate = "";
    let renderDefaultHeight = 0;
    if (createdPolygon.length === 0 || indexOfCreatedPolygon === -1) {
      renderDefaultCoordinate = "[]";
      renderDefaultHeight = 90;
    } else {
      renderDefaultCoordinate = JSON.stringify(
        createdPolygon[indexOfCreatedPolygon].coordinate,
        null,
        2
      )
        .replace(/\[\s+/g, "[")
        .replace(/\s+\]/g, "]")
        .replace(/\s*,\s*/g, ",");

      renderDefaultHeight = chosenHeight[indexOfCreatedPolygon];
    }
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <input
          defaultValue={renderDefaultCoordinate}
          style={{ width: "65%", fontSize: "15px" }}
          readOnly
        />
        <button
          style={{
            width: "10%",
            borderRadius: "100%",
            borderWidth: "0px",
            backgroundColor: "red",
            color: "white",
          }}
          onClick={() => {
            // const removingItem = createdPolygon.filter(
            //   (content, index) => index !== indexOfCreatedPolygon
            // );
            // setCreatedPolygon(removingItem);
            setCreatedPolygon([]);
            setShortestPathMarker([]);
            setShortestPathgGeoJson();
            setIsShortestPathFound(false);
          }}
        >
          X
        </button>
        <input
          type="number"
          defaultValue={renderDefaultHeight}
          min={0}
          max={90}
          onBlur={(event) => {
            const updatedChosenHeight = [...chosenHeight];
            updatedChosenHeight[indexOfCreatedPolygon] = event.target.value;
            setChosenHeight(updatedChosenHeight);
          }}
          style={{ width: "25%", fontSize: "15px" }}
        />
      </div>
    );
  }

  function RenderPolygonSlot() {
    return <PolygonSlotTemplate key={0} indexOfCreatedPolygon={0} />;
  }

  function RenderCreatedPolygonOnMap() {
    if (createdPolygon.length > 0) {
      const polygonToBeOnMap = [];
      for (let i = 0; i < createdPolygon.length; i++) {
        const formattedCreatedPolygonArray = normalSwapLatLon(
          createdPolygon[i].coordinate
        );
        polygonToBeOnMap.push(
          <Polygon
            key={i}
            pathOptions={{
              color:
                createdPolygon[i].isIntersected === false ? "green" : "red",
              fillColor:
                createdPolygon[i].isIntersected === false
                  ? "lightgreen"
                  : "pink",
              fillOpacity: 0.5,
            }}
            positions={formattedCreatedPolygonArray}
          />
        );
      }
      return polygonToBeOnMap;
    } else {
      return null;
    }
  }

  function RenderDroneSelection() {
    const droneOptions = [];
    for (let i = 0; i < availableDrone.length; i++) {
      if (
        typeof availableDrone[i] !== "string" ||
        !availableDrone[i].includes("-")
      ) {
        continue;
      }
      const [id, brand, name, weight] = availableDrone[i]
        .split("-")
        .map((item) => item.trim());

      droneOptions.push(
        <option
          key={id}
          value={JSON.stringify({
            droneID: availableDrone[i],
            droneWeight: weight,
          })}
        >
          {`${brand}-${name}`}
        </option>
      );
    }
    return droneOptions.length > 0 ? droneOptions : null;
  }

  function RenderPurposeSelection() {
    if (typeof selectedDrone !== "string" || !selectedDrone.includes("-")) {
      return null;
    }
    const selectedDroneID = parseInt(selectedDrone.split("-")[0].trim());
    const purposeToChoose = availablePurpose[selectedDroneID].id
      ? availablePurpose[selectedDroneID].id
      : availablePurpose[selectedDroneID];
    if (!Array.isArray(purposeToChoose)) {
      return null;
    }

    const purposeForSelection = purposeToChoose.map((id) => {
      if (id === 7) {
        return {
          id: 7,
          purpose: availablePurpose[selectedDroneID].etc_content,
        };
      } else {
        const matchingObject = fetchedPurpose.find(
          (obj) => obj.purpose_id === id
        );
        return matchingObject
          ? { id: matchingObject.purpose_id, purpose: matchingObject.purpose }
          : null;
      }
    });
    const purposeOptions = [];

    for (let i = 0; i < purposeForSelection.length; i++) {
      if (purposeForSelection[i].id === 7) {
        setEtcPurposeContent(purposeForSelection[i].purpose);
        purposeOptions.push(
          <option
            key={purposeForSelection[i].id}
            value={`${purposeForSelection[i].id}`}
          >
            {purposeForSelection[i].purpose}
          </option>
        );
      } else {
        purposeOptions.push(
          <option
            key={purposeForSelection[i].id}
            value={purposeForSelection[i].id}
          >
            {purposeForSelection[i].purpose}
          </option>
        );
      }
    }
    return purposeOptions;
  }

  function RenderPilotSelection() {
    const filteredPilots = {};
    availablePilot.forEach((item) => {
      const [id, name, type, age] = item.split("-");
      const idNum = parseInt(id);

      if (!filteredPilots[type]) {
        filteredPilots[type] = [];
      }
      filteredPilots[type].push({ id: idNum, name: name.trim(), age: age });
    });
    const pilotOptions = [];
    const parsedIntSelectedPurpose = parseInt(selectedPurpose);
    if (filteredPilots.OPEN) {
      for (let i = 0; i < filteredPilots.OPEN.length; i++) {
        pilotOptions.push(
          <option
            key={filteredPilots.OPEN[i].id}
            value={JSON.stringify({
              pilotID: filteredPilots.OPEN[i].id,
              pilotAge: filteredPilots.OPEN[i].age,
            })}
          >
            {`${filteredPilots.OPEN[i].name} (OPEN)`}
          </option>
        );
      }
    }
    if (filteredPilots.SPECIFIC) {
      for (let i = 0; i < filteredPilots.SPECIFIC.length; i++) {
        pilotOptions.push(
          <option
            key={filteredPilots.SPECIFIC[i].id}
            value={JSON.stringify({
              pilotID: filteredPilots.SPECIFIC[i].id,
              pilotAge: filteredPilots.SPECIFIC[i].age,
            })}
          >
            {`${filteredPilots.SPECIFIC[i].name} (SPECIFIC)`}
          </option>
        );
      }
    }

    return pilotOptions.length > 0 ? pilotOptions : null;
  }

  function RenderShortestPathOnMap() {
    if (shortestPathgGeoJson) {
      return (
        <GeoJSON
          data={shortestPathgGeoJson}
          style={() => ({
            color: "green",
            fillColor: "lightgreen",
          })}
          onEachFeature={onEachProperties}
        />
      );
    }
    return null;
  }

  function RenderShortestPathPolygonLineSubmittion() {
    let renderDefaultShortestPathMarkerA = "[]";
    let renderDefaultShortestPathMarkerB = "[]";
    let renderDeafultShortestPolygon = "[]";
    let polygonCoordinate;
    if (shortestPathgGeoJson) {
      polygonCoordinate =
        shortestPathgGeoJson.features[1].geometry.coordinates[0];
    }

    if (shortestPathMarker.length > 0) {
      renderDefaultShortestPathMarkerA = JSON.stringify(shortestPathMarker[0]);
      renderDefaultShortestPathMarkerB = JSON.stringify(shortestPathMarker[1]);
      renderDeafultShortestPolygon = JSON.stringify(polygonCoordinate);
    }

    return (
      <>
        <div className="input-section" style={{ height: "auto" }}>
          <h5>ตำแหน่งจุด A | ตำแหน่งจุด B | ความสูง</h5>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              defaultValue={renderDefaultShortestPathMarkerA}
              style={{ width: "37.5%", fontSize: "15px" }}
              readOnly
            />
            <input
              defaultValue={renderDefaultShortestPathMarkerB}
              style={{ width: "37.5%", fontSize: "15px" }}
              readOnly
            />
            <button
              style={{
                width: "10%",
                borderRadius: "100%",
                borderWidth: "0px",
                backgroundColor: "red",
                color: "white",
              }}
              onClick={() => {
                setCreatedPolygon([]);
                setShortestPathMarker([]);
                setShortestPathgGeoJson();
                setIsShortestPathFound(false);
              }}
            >
              X
            </button>
            <input
              type="number"
              min={20}
              max={90}
              defaultValue={shortestPathUpperHeight}
              style={{ width: "25%", fontSize: "15px" }}
              onBlur={(event) => {
                setShortestPathUpperHeight(event.target.value);
              }}
            />
          </div>
        </div>
        {isShortestPathFound === true ? (
          <div className="button-section">
            <button
              className="modal-footer30 btn-confirm"
              style={{
                width: "80%",
                marginTop: "40px",
                background:
                  "linear-gradient(0deg, rgba(102,0,0,1) 0%, rgba(207,57,57,1) 100%)",
              }}
              onClick={() => {
                setCreatedPolygon([]);
                setIsShortestPathFound(false);
                setShortestPathMarker([]);
                setShortestPathgGeoJson();
              }}
            >
              ยกเลิกคำนวนเส้นทาง
            </button>
          </div>
        ) : (
          <div className="button-section">
            <button
              className="modal-footer30 btn-confirm"
              style={{ width: "80%", marginTop: "40px" }}
              onClick={() => {
                setModalToggle({ ...modalToggle, modalwait: true });
                findShortestPolyline();
              }}
            >
              คำนวนเส้นทางที่สั้นที่สุด
            </button>
          </div>
        )}

        <div className="input-section" style={{ height: "auto" }}>
          <div style={{ display: "flex" }}>
            <h5>ตำแหน่งพื้นที่ </h5>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              defaultValue={renderDeafultShortestPolygon}
              style={{ width: "100%", fontSize: "15px" }}
              readOnly
            />
          </div>
        </div>

        <div
          style={{
            width: "90%",
            height: "auto",
            padding: "10px 10px",
          }}
        >
          <table>
            <tbody>
              {checkboxComfirmation != null
                ? Object.keys(checkboxComfirmation.label).map((key) => {
                    if (typeof checkboxComfirmation.label[key] === "string") {
                      return (
                        <tr key={key}>
                          <td
                            style={{
                              width: "30px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={checkboxComfirmation.check_type[key]}
                              style={{
                                width: "20px",
                                height: "20px",
                                verticalAlign: "top",
                              }}
                              onChange={(e) => handleCheckboxChange(e, key)}
                            />
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            <label>{checkboxComfirmation.label[key]}</label>
                          </td>
                        </tr>
                      );
                    } else {
                      // Handle nested "เงื่อนไขพิเศษ"
                      if (
                        isAnyTopLevelUnchecked() ||
                        hasOnlySpecificKey(
                          checkboxComfirmation.check_type,
                          "เงื่อนไขพิเศษ"
                        )
                      ) {
                        return Object.keys(checkboxComfirmation.label[key]).map(
                          (nestedKey) => (
                            <tr key={nestedKey}>
                              <td
                                style={{
                                  width: "30px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={
                                    checkboxComfirmation.check_type
                                      .เงื่อนไขพิเศษ[nestedKey]
                                  }
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    verticalAlign: "top",
                                  }}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, nestedKey, true)
                                  }
                                />
                              </td>
                              <td
                                style={{
                                  paddingLeft: "10px",
                                  borderBottom: "1px solid black",
                                }}
                              >
                                <label>
                                  {checkboxComfirmation.label[key][nestedKey]}
                                </label>
                              </td>
                            </tr>
                          )
                        );
                      }
                    }
                  })
                : null}
            </tbody>
          </table>
        </div>

        {isShortestPathFound === true && checkboxComfirmation != null ? (
          <div className="button-section">
            <button
              className="modal-footer30 btn-confirm"
              style={{ width: "80%" }}
              onClick={() => {
                checkAllPolygon();
              }}
            >
              ประเมินแผน
            </button>
          </div>
        ) : null}
      </>
    );
  }

  function RenderEstimatingSuccessModal() {
    let renderDefaultCoordinate = "";
    let renderDefaultHeight = 0;
    let renderDefaultPurpose = "";
    let renderDefaultPolicy = "";

    if (createdPolygon.length != 0) {
      for (let i = 0; i < createdPolygon.length; i++) {
        renderDefaultCoordinate = JSON.stringify(
          createdPolygon[i].coordinate,
          null,
          2
        )
          .replace(/\[\s+/g, "[")
          .replace(/\s+\]/g, "]")
          .replace(/\s*,\s*/g, ",");
        renderDefaultHeight = chosenHeight[i];
      }
    }

    if (fetchedPurpose.length > 0 && selectedPurpose !== "") {
      if (selectedPurpose === "7") {

        renderDefaultPurpose = etcPurposeContent;
      } else {
        renderDefaultPurpose = fetchedPurpose[selectedPurpose - 1].purpose;
      }
    }

    if (estimateSuccessStatus.time === "DAY") {
      renderDefaultPolicy =
        "คุณสามารถบันทึกแผนในระบบเพื่อแสดงเป็นหลักฐานแก่หน่วยงานที่เกี่ยวข้องและสามารถแสดงเป็นรายงานแผนการบินได้";
    } else if (estimateSuccessStatus.time === "NIGHT") {
      renderDefaultPolicy =
        "แผนการบินของท่านจะถูกส่งให้แก่สำนักงานการบินพลเรือนแห่งประเทศไทยเพื่อให้หน่วยงานดังกล่าวตรวจสอบและอนุมัติแผนการบินพร้อมทั้งวัตถุประสงค์การบินข้างต้น";
    }

    const handleDownload = async (filename) => {
      // Trigger a download using a dynamically created link
      try {
        const respone = await AuthServiceV3.Getfile(filename);
        const file = new Blob([respone.data], { type: respone.data.type });
        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, "_blank");
      } catch (error) {
        console.error("File download error:", error);
      }
    };

    return (
      <Modal
        size="lg"
        show={showEstimateSuccess}
        onHide={() => {
          setShowEstimateSuccess(false);
          // setConfirmSend(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <div style={{ display: "flex" }}>
              <h3
                style={{
                  // color: confirmSend === true ? "black" : "grey",
                  color: "black",
                  letterSpacing: "1px",
                }}
              >
                ยืนยันการส่งคำขออนุญาต
              </h3>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>ประเภทของแผน</h5>
          <h6
            style={{
              color:
                operationScenario === "STANDARD"
                  ? "#0F70E0"
                  : operationType === "SPECIFIC"
                  ? "orange"
                  : operationType === "OPEN"
                  ? "green"
                  : "black",
            }}
          >
            {" "}
            {`${operationType}${
              operationScenario === "NORMAL" || operationScenario === "ADVANCE"
                ? ""
                : " - " + operationScenario + " SCENARIO"
            }`}
            {/* {selectedPurpose >= 5 ? "SPECIFIC" : "OPEN"} */}
          </h6>
          <h5>โดรนที่ท่านเลือก</h5>
          <h6>
            {`${selectedDrone.toString().split("-")[1]}-${
              selectedDrone.toString().split("-")[2]
            }`}
          </h6>
          <h5>วัตถุประสงค์</h5>
          <h6>{renderDefaultPurpose}</h6>
          <h5>วันและเวลาเริ่มต้น</h5>
          <h6>
            {("0" + dayTimeStart["$D"]).slice(-2)}/
            {("0" + (dayTimeStart["$M"] + 1)).slice(-2)}/{dayTimeStart["$y"]} -{" "}
            {("0" + dayTimeStart["$H"]).slice(-2)} :{" "}
            {("0" + dayTimeStart["$m"]).slice(-2)} : 00
          </h6>
          <h5>วันและเวลาสิ้นสุด</h5>
          <h6>
            {("0" + dayTimeEnd["$D"]).slice(-2)}/
            {("0" + (dayTimeEnd["$M"] + 1)).slice(-2)}/{dayTimeEnd["$y"]} -{" "}
            {("0" + dayTimeEnd["$H"]).slice(-2)} :{" "}
            {("0" + dayTimeEnd["$m"]).slice(-2)} : 00
          </h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>พื้นที่ที่เลือก (ลองจิจูด, ละติจูด) กดที่ตัวเลขเพื่อคัดลอก</h5>
          <h6
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigator.clipboard
                .writeText(renderDefaultCoordinate)
                .then(() => {
                  console.log(
                    "Text copied to clipboard:",
                    renderDefaultCoordinate
                  );
                })
                .catch((err) => {
                  console.error("Failed to copy text: ", err);
                });
            }}
          >
            {renderDefaultCoordinate.substring(0, 60)}......
          </h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>ความสูง</h5>
          <h6>{renderDefaultHeight} เมตร</h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>เอกสารสำคัญ</h5>
          <p style={{ fontWeight: "bold" }}>{renderDefaultPolicy}</p>
          {/* {operationType === "SPECIFIC" ? (
            <button
              onClick={() => {
                setShowAgreement(true);
              }}
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "inherit",
                cursor: "pointer",
                padding: "0",
                textDecoration: "underline",
                color: "blue",
              }}
            >
              กดเพื่ออ่านกฏข้อบังคับการบินในแผนประเภท SPECIFIC
            </button>
          ) : null} */}
          <div>
            <table style={{ marginBottom: "25px" }}>
              <tbody>
                {Object.keys(estimatedOperationFile).map((key) => {
                  const file = estimatedOperationFile[key];
                  return (
                    <tr key={key}>
                      <td>
                        {file.name} ({(file.size / 1024).toFixed(2)} KB)
                      </td>
                      <td>
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "inherit",
                            cursor: "pointer",
                            paddingLeft: "10px",
                            textDecoration: "underline",
                            color: "blue",
                          }}
                          onClick={() => handleDownload(file.path)}
                        >
                          Download
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ width: "100%", height: "400px" }}>
            <MapContainer
              center={centerBetweenPolygon}
              zoom={13}
              keyboard={true}
              style={{ width: "100%", height: "100%" }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <RenderCreatedPolygonOnMap />
              <RenderShortestPathOnMap />
            </MapContainer>
          </div>
          {/* <div style={{ display: "flex" }}>
            <input
              style={{ width: "25px", height: "25px", margin: "auto 0px" }}
              type="checkbox"
              checked={confirmSend === true ? true : null}
              onChange={() => {
                if (confirmSend === false) {
                  setConfirmSend(true);
                } else {
                  setConfirmSend(false);
                }
              }}
            />
            <h4
              style={{
                fontWeight: "300",
                whiteSpace: "nowrap",
                margin: "auto 0px auto 10px",
              }}
            >
              คุณยอมรับกับข้อตกลงหรือไม่
            </h4>
          </div> */}
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
            }}
            className="modal-footer30 btn-confirm"
            onClick={() => {
              setEstimateSuccessStatus({ status: null, time: null });
              setEstimateID("");
              setShowEstimateSuccess(false);
            }}
          >
            ยกเลิก
          </button>
          {/* <button
            style={{
              height: "50px",
              width: "40%",
              backgroundImage: confirmSend
                ? "linear-gradient(97.41deg, #023E8A, #0096C7)"
                : "linear-gradient(0deg, rgba(54,54,54,1) 0%, rgba(181,181,181,1) 81%)",
              cursor: confirmSend ? "pointer" : "default",
            }}
            className="modal-footer30 btn-confirm"
            onClick={() => {
              if (confirmSend === true) {
                confirmSendInfo();
                setShowEstimateSuccess(false);
                setModalToggle({ ...modalToggle, modalSuccess: true });
              }
            }}
          >
            บันทึกแผน
          </button> */}
          <button
            style={{
              height: "50px",
              width: "40%",
              backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
              cursor: "pointer",
            }}
            className="modal-footer30 btn-confirm"
            onClick={() => {
              confirmSendInfo();
            }}
          >
            บันทึกแผน
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div>
      <RenderEstimatingSuccessModal />
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      <Modal
        show={showErroroperation}
        onHide={() => setShowErroroperation(false)}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ท่านยังไม่ได้ลงทะเบียนโดรน หรือ โดรนของท่านยังไม่ได้รับการอนุมัติ{" "}
        </Modal.Body>
      </Modal>
      <Modal
        show={showAgreement}
        onHide={() => {
          setShowAgreement(false);
          setAgreementPage(1);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3>ข้อตกลงก่อนทำการบิน</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <table
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
                fontSize: "15px",
              }}
            >
              <thead>
                <tr>
                  <th className="table-space">เนื้อหา</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "15px" }}>
                {agreementContent.map((content, index) => {
                  return (
                    <tr
                      key={index}
                      style={index % 2 === 0 ? { background: "#f2f2f2" } : {}}
                    >
                      <td
                        className="table-space"
                        style={{
                          width: "75%",
                          margin: "0px",
                          textAlign: "left",
                          paddingLeft: "25px",
                        }}
                      >
                        <p style={{ fontSize: "20px" }}>{content.text}</p>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "15px",
              color: "white",
            }}
            onClick={() => {
              if (agreementPage > 1) {
                setAgreementPage(agreementPage - 1);
              } else {
                setShowAgreement(false);
                setShowSend(false);
              }
            }}
          >
            ย้อนกลับ
          </button>
        </Modal.Footer>
      </Modal>
      <div
        style={{
          height: "93.25vh",
          width: "100%",
          display: "flex",
        }}
      >
        <MapContainer
          center={[13.101029105523143, 100.92994760607247]}
          zoom={13}
          keyboard={true}
          style={{ width: "100%", height: "100%" }}
          ref={mapRef}
        >
          <RenderCreatedPolygonOnMap />
          <RenderShortestPathOnMap />
          {coopArea && chosenForm === 2 ? (
            <Polygon
              pathOptions={{
                color: "orange",
                fillColor: "yellow",
                fillOpacity: 0.6,
              }}
              positions={coopArea}
            />
          ) : null}
          <RenderSpecificedTimePolygon></RenderSpecificedTimePolygon>
          {coopArea.length > 0 ? (
            <Polygon
              pathOptions={{
                color: "orange",
                fillColor: "yellow",
                fillOpacity: 0.6,
              }}
              positions={coopArea}
            />
          ) : null}
          <FeatureGroup>
            <EditControl
              position="topright"
              onCreated={handleCreation}
              draw={{
                polyline:
                  createdPolygon.length < 1 &&
                  shortestPathMarker.length < 1 &&
                  displayPlans === 2
                    ? {
                        allowIntersection: false,
                        showArea: true,
                        showLength: true,
                        metric: ["km", "m"],
                        shapeOptions: {
                          color: "green",
                          fillColor: "white",
                          fillOpacity: 0.0,
                        },
                        repeatMode: true,
                        maxPoints: 2,
                      }
                    : false,
                polygon:
                  createdPolygon.length < 1 &&
                  shortestPathMarker.length < 1 &&
                  displayPlans === 1
                    ? {
                        allowIntersection: false,
                        showArea: true,
                        showLength: true,
                        metric: ["km", "m"],
                        shapeOptions: {
                          color: "green",
                          fillColor: "white",
                          fillOpacity: 0.0,
                        },
                      }
                    : false,
                rectangle: false,
                circle:
                  createdPolygon.length < 1 &&
                  shortestPathMarker.length < 1 &&
                  displayPlans === 1
                    ? {
                        shapeOptions: {
                          color: "green",
                          fillColor: "white",
                          fillOpacity: 0.0,
                        },
                      }
                    : false,
                marker: false,
                circlemarker: false,
              }}
              edit={{
                remove: false,
                edit: false,
              }}
            />
          </FeatureGroup>
          {shortestPathMarker.length > 0 ? (
            <Polyline
              positions={[
                [shortestPathMarker[0][1], shortestPathMarker[0][0]],
                [shortestPathMarker[1][1], shortestPathMarker[1][0]],
              ]}
            />
          ) : null}

          <Control prepend position="topright">
            <button
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "35px",
                width: "35px",
                backgroundColor: "white",
                borderWidth: "1px",
                borderColor: "grey",
                color: "black",
              }}
              className="btn btn-primary"
              onClick={showMyLocation}
            >
              <GoLocation />
            </button>
          </Control>
          <LayersControl position="bottomright">
            <LayersControl.BaseLayer name="Google Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer checked name="OpenStreet Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.Overlay checked name="Aerodome area">
              {Aerodrome && (
                <GeoJSON
                  data={Aerodrome}
                  style={{
                    color: "orange",
                    fillColor: "orange",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Flight prohibitation area">
              {PDRArea && (
                <GeoJSON
                  data={PDRArea}
                  style={{
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Hospital area">
              {hospital && (
                <GeoJSON
                  data={hospital}
                  style={{
                    color: "purple",
                    fillColor: "purple",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Goverment Office area">
              {govOffice && (
                <GeoJSON
                  data={govOffice}
                  style={{
                    color: "blue",
                    fillColor: "blue",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Embassy area">
              {embassy && (
                <GeoJSON
                  data={embassy}
                  style={{
                    color: "yellow",
                    fillColor: "yellow",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Police department area">
              {policeDepartment && (
                <GeoJSON
                  data={policeDepartment}
                  style={{
                    color: "green",
                    fillColor: "green",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Thai Goverment area">
              {thaiGov && (
                <GeoJSON
                  data={thaiGov}
                  style={{
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 1,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            {bangkokPopulation && populationShow === true ? (
              <GeoJSON
                data={bangkokPopulation}
                style={bangkokPopulationColorized}
                onEachFeature={onEachFeature}
              />
            ) : null}
          </LayersControl>
          <Control prepend position="bottomleft">
            <div
              style={{
                width: "250px",
                backgroundColor: "white",
                borderWidth: "1px",
                borderColor: "grey",
                color: "black",
              }}
            >
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "16px", margin: "0px auto" }}>
                  <input
                    style={{
                      marginRight: "5px",
                      height: "14px",
                      width: "15px",
                    }}
                    type="checkbox"
                    checked={populationShow}
                    onChange={() => {
                      if (populationShow === false) {
                        setPopulationShow(true);
                      } else {
                        setPopulationShow(false);
                      }
                    }}
                  />
                  ข้อมูลความหนาแน่นประชากร
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "10px",
                }}
              >
                สีของความหนาแน่นประชากร
              </div>
              <div
                style={{
                  paddingTop: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "10px",
                }}
              >
                <table>
                  <thead>
                    <tr>
                      <th style={{ padding: "0px 10px" }}>สี</th>
                      <th style={{ padding: "0px 10px" }}>จำนวนประชากร</th>
                    </tr>
                  </thead>
                  <tbody>
                    {legendPopulation.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            color: "red",
                            opacity: item.color,
                            padding: "0px 10px",
                          }}
                        >
                          <FaCircle />
                        </td>
                        <td style={{ padding: "0px 10px" }}>
                          {item.population}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Control>
        </MapContainer>
        {sidebarMain === true ? (
          <>
            <div
              className="sidebar-main"
              style={{
                position: "relative",
                top: "0px",
                height: "auto",
                width: "30%",
                animation: "none",
              }}
            >
              <Offcanvas.Header
                className="sidebar-header"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Offcanvas.Title>
                  <div style={{ display: "flex" }}>
                    <h3> สร้างแผนการบิน </h3>
                    <a
                      href="/user/operation/full-agreement-page"
                      target="_blank"
                    >
                      <div
                        style={{
                          marginLeft: "5px",
                          marginTop: "7.5px",
                          fontSize: "15px",
                          width: "20px",
                          height: "20px",
                          borderRadius: "100px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          border: "2px solid black",
                          textDecoration: "none",
                          color: "black",
                        }}
                      >
                        i
                      </div>
                    </a>
                  </div>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Tabs
                  fill
                  id="controlled-tabs"
                  defaultActiveKey={displayPlans}
                  onSelect={(event) => {
                    setDisplayPlans(parseInt(event));
                  }}
                  style={{
                    marginTop: "20px",
                    color: "#0077B6",
                    fontSize: "15px",
                    borderWidth: "5px",
                  }}
                >
                  <Tab
                    eventKey="1"
                    className="nav-link-test"
                    title={
                      <span
                        className="tabplan"
                        style={{
                          color: "#0077B6",
                          fontWeight: "500",
                        }}
                      >
                        แผนการบินแบบรูปทรง
                      </span>
                    }
                  >
                    <div
                      className="sidebar-wrapper"
                      style={{ overflowX: "hidden" }}
                    >
                      <div
                        className="sidebar-card"
                        style={{
                          boxShadow: "0px 0px 0px 0px",
                          backgroundColor: "white",
                          padding: "0px 0px",
                          marginLeft: "auto",
                          marginRight: "auto",
                          width: "100%",
                        }}
                      >
                        <div
                          className="sidebar-card-body"
                          style={{
                            height: "700px",
                            width: "95%",
                            marginLeft: "auto",
                            marginRight: "auto",
                            overflowY: "scroll",
                            overflowX: "hidden",
                            scrollbarWidth: "none",
                          }}
                        >
                          <div className="form-content">
                            <div className="special-input-section">
                              <h5>เวลาเริ่มต้นการบิน</h5>
                              <div style={{ width: "100%" }}>
                                {" "}
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DateTimePicker
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          "& .MuiInputBase-root": {
                                            height: "40px",
                                            width: "100%",
                                            fontSize: "15px",
                                            borderWidth: "0px",
                                            borderRadius: "100px",
                                            backgroundColor: "white",
                                          },
                                        },
                                        fullWidth: true,
                                      },
                                    }}
                                    ampm={false}
                                    closeOnSelect={true}
                                    shouldDisableDate={shouldDisableStartDate}
                                    // shouldDisableTime={shouldDisableStartTime}
                                    value={dayTimeStart}
                                    onClose={(event) => {
                                      getAvailableInformation();
                                      setselectedDrone("");
                                      setSelectedPilot("");
                                      setSelectedPurpose("");
                                      setSecondDropDownID();
                                      setCheckboxConfirmation(null);

                                      setTimeout(() => {
                                        setIsTimeBeingSet(!isTimeBeingSet);
                                      }, 500);
                                    }}
                                    onChange={handleChangeStart}
                                  />
                                </LocalizationProvider>
                              </div>
                            </div>
                            <div className="special-input-section">
                              <h5>เวลาสิ้นสุดการบิน</h5>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                  slotProps={{
                                    textField: {
                                      sx: {
                                        "& .MuiInputBase-root": {
                                          height: "40px",
                                          width: "100%",
                                          fontSize: "15px",
                                          borderWidth: "0px",
                                          borderRadius: "100px",
                                          backgroundColor: "white",
                                        },
                                      },
                                      fullWidth: true,
                                    },
                                  }}
                                  ampm={false}
                                  closeOnSelect={true}
                                  shouldDisableTime={shouldDisableEndDate}
                                  shouldDisableDate={shouldDisableEndTime}
                                  value={dayTimeEnd}
                                  onClose={() => {
                                    // getPolygonPosition();
                                    getAvailableInformation();
                                    setselectedDrone("");
                                    setSelectedPilot("");
                                    setSelectedPurpose("");
                                    setSecondDropDownID();
                                    setCheckboxConfirmation(null);
                                    setTimeout(() => {
                                      setIsTimeBeingSet(!isTimeBeingSet);
                                    }, 500);
                                  }}
                                  onChange={handleChangeEnd}
                                />
                              </LocalizationProvider>
                            </div>
                            <div className="input-section">
                              <h5>เลือกอากาศยาน</h5>
                              <select
                                value={
                                  selectedDrone
                                    ? JSON.stringify({
                                        droneID: selectedDrone,
                                        droneWeight: selectedDroneWeight,
                                      })
                                    : ""
                                }
                                className="dropdown-field"
                                style={{ fontSize: "15px" }}
                                onChange={(event) => {
                                  const selectedDrone = JSON.parse(
                                    event.target.value
                                  );

                                  setselectedDrone(selectedDrone.droneID);
                                  setselectedDroneWeight(
                                    selectedDrone.droneWeight
                                  );

                                  setCheckboxConfirmation(null);
                                  setSecondDropDownID();
                                  setSelectedPilot("");
                                }}
                              >
                                <option
                                  value=""
                                  disabled
                                  style={{ fontSize: "15px" }}
                                >
                                  เลือกโดรนที่จะเข้าร่วม
                                </option>
                                {/* <option value="">-</option> */}
                                <RenderDroneSelection />
                              </select>
                              <h6
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "2px",
                                  fontSize: "10px",
                                }}
                              >
                                น้ำหนัก {selectedDroneWeight} กิโลกรัม
                              </h6>
                            </div>
                            <div className="input-section">
                              <h5>เลือกวัตถุประสงค์การบิน</h5>
                              <select
                                value={selectedPurpose.toString()}
                                className="dropdown-field"
                                style={{ fontSize: "15px" }}
                                onChange={(event) => {
                                  if (/^\d+$/.test(event.target.value)) {
                                    setSelectedPurpose(event.target.value);
                                    setEtcPurposeContent("");
                                    setCheckboxConfirmation(null);
                                    setSecondDropDownID();
                                    setSelectedPilot("");
                                  } else {
                                    const tempChosenPurpose =
                                      event.target.value.split("-");
                                    setSelectedPurpose(tempChosenPurpose[0]);
                                    setEtcPurposeContent(tempChosenPurpose[1]);
                                    setCheckboxConfirmation(null);
                                    setSecondDropDownID();
                                    setSelectedPilot("");
                                  }
                                }}
                              >
                                <option value="" disabled>
                                  เลือกวัตถุประสงค์ของคุณ
                                </option>
                                {/* <option value="">-</option> */}
                                <RenderPurposeSelection />
                              </select>
                            </div>
                            {selectedPurpose != "" ? (
                              <div className="input-section">
                                <h5>เลือกนักบิน</h5>
                                <select
                                  value={
                                    selectedPilot !== ""
                                      ? JSON.stringify({
                                          pilotID: selectedPilot,
                                          pilotAge: selectedPilotAge,
                                        })
                                      : ""
                                  }
                                  className="dropdown-field"
                                  style={{ fontSize: "15px" }}
                                  onChange={(event) => {
                                    handleChangePilot(event.target.value);
                                  }}
                                >
                                  <option value="" disabled>
                                    เลือกนักบินที่จะเข้าร่วม
                                  </option>
                                  {/*  <option value="">-</option> */}
                                  <RenderPilotSelection />
                                </select>
                                <h6
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "2px",
                                    fontSize: "10px",
                                  }}
                                >
                                  อายุ {selectedPilotAge} ปี
                                </h6>
                              </div>
                            ) : null}
                            <div
                              className="input-section"
                              style={{ height: "auto" }}
                            >
                              <div style={{ display: "flex" }}>
                                <h5>ตำแหน่งพื้นที่ | ความสูง</h5>
                              </div>

                              <RenderPolygonSlot />
                              <input
                                style={{
                                  display: "none",
                                }}
                                id="myFileInput"
                                alt="inputdata"
                                type="file"
                                accept=".kml,.kmz"
                                ref={hiddenFileInput}
                                onChange={handleFileInputChange}
                              />
                              <div>
                                {/* change this to 2 later but now 1 */}
                                {createdPolygon.length > 0 ? null : (
                                  <h6
                                    style={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      hiddenFileInput.current.click();
                                    }}
                                  >
                                    <AiOutlineFileAdd />
                                    อัพโหลดไฟล์ KML (ถ้ามี)
                                  </h6>
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                width: "90%",
                                height: "auto",
                                padding: "10px 10px",
                              }}
                            >
                              {checkboxComfirmation != null ? (
                                <h5
                                  style={{
                                    fontSize: "15px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  <u>กรุณาเลือกเงื่อนไขที่ท่านปฏิบัติได้</u>
                                  <sup style={{ color: "red" }}>***</sup>
                                </h5>
                              ) : null}

                              <table>
                                <tbody>
                                  {checkboxComfirmation != null
                                    ? Object.keys(
                                        checkboxComfirmation.label
                                      ).map((key) => {
                                        if (
                                          typeof checkboxComfirmation.label[
                                            key
                                          ] === "string"
                                        ) {
                                          return (
                                            <tr key={key}>
                                              <td
                                                style={{
                                                  width: "30px",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    checkboxComfirmation
                                                      .check_type[key]
                                                  }
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    verticalAlign: "top",
                                                  }}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(e, key)
                                                  }
                                                />
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  borderBottom:
                                                    "1px solid black",
                                                }}
                                              >
                                                <label>
                                                  {
                                                    checkboxComfirmation.label[
                                                      key
                                                    ]
                                                  }
                                                </label>
                                              </td>
                                            </tr>
                                          );
                                        } else {
                                          // Handle nested "เงื่อนไขพิเศษ"
                                          if (
                                            isAnyTopLevelUnchecked() ||
                                            hasOnlySpecificKey(
                                              checkboxComfirmation.check_type,
                                              "เงื่อนไขพิเศษ"
                                            )
                                          ) {
                                            return Object.keys(
                                              checkboxComfirmation.label[key]
                                            ).map((nestedKey) => (
                                              <tr key={nestedKey}>
                                                <td
                                                  style={{
                                                    width: "30px",
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    checked={
                                                      checkboxComfirmation
                                                        .check_type
                                                        .เงื่อนไขพิเศษ[
                                                        nestedKey
                                                      ]
                                                    }
                                                    style={{
                                                      width: "20px",
                                                      height: "20px",
                                                      verticalAlign: "top",
                                                    }}
                                                    onChange={(e) =>
                                                      handleCheckboxChange(
                                                        e,
                                                        nestedKey,
                                                        true
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td
                                                  style={{
                                                    paddingLeft: "10px",
                                                    borderBottom:
                                                      "1px solid black",
                                                  }}
                                                >
                                                  <label>
                                                    {
                                                      checkboxComfirmation
                                                        .label[key][nestedKey]
                                                    }
                                                  </label>
                                                </td>
                                              </tr>
                                            ));
                                          }
                                        }
                                      })
                                    : null}
                                </tbody>
                              </table>
                            </div>
                            {checkboxComfirmation != null ? (
                              <div className="button-section">
                                <button
                                  className="modal-footer30 btn-confirm"
                                  style={{ width: "80%" }}
                                  onClick={() => {
                                    checkAllPolygon();
                                  }}
                                >
                                  ประเมินแผน
                                </button>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="2"
                    className="nav-link-test"
                    title={
                      <span
                        className="tabplan"
                        style={{
                          color: "#0077B6",
                          fontWeight: "500",
                        }}
                      >
                        คำนวนแผนแบบเส้น
                      </span>
                    }
                  >
                    <div
                      className="sidebar-wrapper"
                      style={{ overflowX: "hidden" }}
                    >
                      <div
                        className="sidebar-card"
                        style={{
                          boxShadow: "0px 0px 0px 0px",
                          backgroundColor: "white",
                          padding: "0px 0px",
                          marginLeft: "auto",
                          marginRight: "auto",
                          width: "100%",
                        }}
                      >
                        <div
                          className="sidebar-card-body"
                          style={{
                            height: "700px",
                            width: "95%",
                            marginLeft: "auto",
                            marginRight: "auto",
                            overflowY: "scroll",
                            overflowX: "hidden",
                            scrollbarWidth: "none",
                          }}
                        >
                          <div className="form-content">
                            <div className="special-input-section">
                              <h5>เวลาเริ่มต้นการบิน</h5>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                  slotProps={{
                                    textField: {
                                      sx: {
                                        "& .MuiInputBase-root": {
                                          height: "40px",
                                          width: "100%",
                                          fontSize: "15px",
                                          borderWidth: "0px",
                                          borderRadius: "100px",
                                          backgroundColor: "white",
                                        },
                                      },
                                      fullWidth: true,
                                    },
                                  }}
                                  ampm={false}
                                  closeOnSelect={true}
                                  shouldDisableDate={shouldDisableStartDate}
                                  shouldDisableTime={shouldDisableStartTime}
                                  value={dayTimeStart}
                                  onClose={(event) => {
                                    getAvailableInformation();
                                    setselectedDrone("");
                                    setSelectedPilot("");
                                    setSelectedPurpose("");
                                    setSecondDropDownID();
                                    setCheckboxConfirmation(null);
                                    setTimeout(() => {
                                      setIsTimeBeingSet(!isTimeBeingSet);
                                    }, 500);
                                  }}
                                  onChange={handleChangeStart}
                                />
                              </LocalizationProvider>
                            </div>
                            <div className="special-input-section">
                              <h5>เวลาสิ้นสุดการบิน</h5>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                  slotProps={{
                                    textField: {
                                      sx: {
                                        "& .MuiInputBase-root": {
                                          height: "40px",
                                          width: "100%",
                                          fontSize: "15px",
                                          borderWidth: "0px",
                                          borderRadius: "100px",
                                          backgroundColor: "white",
                                        },
                                      },
                                      fullWidth: true,
                                    },
                                  }}
                                  ampm={false}
                                  closeOnSelect={true}
                                  shouldDisableTime={shouldDisableEndDate}
                                  shouldDisableDate={shouldDisableEndTime}
                                  value={dayTimeEnd}
                                  onClose={() => {
                                    // getPolygonPosition();
                                    getAvailableInformation();
                                    setselectedDrone("");
                                    setSelectedPilot("");
                                    setSelectedPurpose("");
                                    setSecondDropDownID();
                                    setCheckboxConfirmation(null);
                                    setTimeout(() => {
                                      setIsTimeBeingSet(!isTimeBeingSet);
                                    }, 500);
                                  }}
                                  onChange={handleChangeEnd}
                                />
                              </LocalizationProvider>
                            </div>
                            <div className="input-section">
                              <h5>เลือกอากาศยาน</h5>
                              <select
                                value={
                                  selectedDrone
                                    ? JSON.stringify({
                                        droneID: selectedDrone,
                                        droneWeight: selectedDroneWeight,
                                      })
                                    : ""
                                }
                                className="dropdown-field"
                                style={{ fontSize: "15px" }}
                                onChange={(event) => {
                                  {
                                    setselectedDrone(event.target.value);
                                    const selectedDrone = JSON.parse(
                                      event.target.value
                                    );
                                    setselectedDrone(selectedDrone.droneID);
                                    setselectedDroneWeight(
                                      selectedDrone.droneWeight
                                    );
                                  }
                                  setCheckboxConfirmation(null);
                                  setSecondDropDownID();
                                  setSelectedPilot("");
                                }}
                              >
                                <option
                                  value=""
                                  disabled
                                  style={{ fontSize: "15p" }}
                                >
                                  เลือกโดรนที่จะเข้าร่วม
                                </option>
                                {/* <option value="">-</option> */}
                                <RenderDroneSelection />
                              </select>
                              <h6
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "2px",
                                  fontSize: "10px",
                                }}
                              >
                                น้ำหนัก {selectedDroneWeight} กิโลกรัม
                              </h6>
                            </div>
                            <div className="input-section">
                              <h5>เลือกวัตถุประสงค์การบิน</h5>
                              <select
                                value={selectedPurpose.toString()}
                                className="dropdown-field"
                                style={{ fontSize: "15px" }}
                                onChange={(event) => {
                                  setSelectedPurpose(event.target.value);
                                }}
                              >
                                <option value="" disabled>
                                  เลือกวัตถุประสงค์ของคุณ
                                </option>
                                {/* <option value="">-</option> */}
                                <RenderPurposeSelection />
                              </select>
                            </div>
                            {selectedPurpose != "" ? (
                              <div className="input-section">
                                <h5>เลือกนักบิน</h5>
                                <select
                                  value={
                                    selectedPilot
                                      ? JSON.stringify({
                                          pilotID: selectedPilot,
                                          pilotAge: selectedPilotAge,
                                        })
                                      : ""
                                  }
                                  className="dropdown-field"
                                  style={{ fontSize: "15px" }}
                                  onChange={(event) =>
                                    handleChangePilot(event.target.value)
                                  }
                                >
                                  <option value="" disabled>
                                    เลือกนักบินที่จะเข้าร่วม
                                  </option>
                                  {/* <option value="">-</option> */}
                                  <RenderPilotSelection />
                                </select>
                                <h6
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "2px",
                                    fontSize: "10px",
                                  }}
                                >
                                  อายุ {selectedPilotAge} ปี
                                </h6>
                              </div>
                            ) : null}
                            <RenderShortestPathPolygonLineSubmittion />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </Offcanvas.Body>
              <OverlayTrigger
                key={"right"}
                placement={"right"}
                overlay={<Tooltip id={`tooltip-${"right"}`}>Close</Tooltip>}
              >
                <div
                  className="toNavSide-btn icon-pointer"
                  style={{
                    top: "50%",
                    borderRadius: "0px 10px 10px 0px",
                    animation: "none",
                    width: "12.5px",
                  }}
                  onClick={() => {
                    setSidebarMain(!sidebarMain);
                  }}
                >
                  <MdDoubleArrow />
                </div>
              </OverlayTrigger>
            </div>
          </>
        ) : (
          <div
            className="sidebar-main"
            style={{
              position: "relative",
              top: "0px",
              height: "auto",
              width: "1%",
              animation: "none",
            }}
          >
            <OverlayTrigger
              key={"right"}
              placement={"left"}
              overlay={<Tooltip id={`tooltip-${"left"}`}>Open</Tooltip>}
            >
              <div
                className="toNavSide-btn icon-pointer"
                style={{
                  top: "50%",
                  borderRadius: "10px 0px 0px 10px",
                  right: "0px",
                  animation: "none",
                }}
                onClick={() => {
                  setSidebarMain(!sidebarMain);
                }}
              >
                <MdDoubleArrow style={{ transform: "scaleX(-1)" }} />
              </div>
            </OverlayTrigger>
          </div>
        )}
      </div>
    </div>
  );
}

export default PolygonLeafLet;
